/* tslint:disable */
/* eslint-disable */
/**
 * NfnAPi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postalCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'primary'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminRegion
 */
export interface AdminRegion {
    /**
     * 
     * @type {string}
     * @memberof AdminRegion
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminRegion
     */
    'code'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ApplicationTypeEnum = {
    Newapp: 'NEWAPP',
    Delete: 'DELETE',
    Rstore: 'RSTORE',
    Gchnge: 'GCHNGE',
    Uitrep: 'UITREP'
} as const;

export type ApplicationTypeEnum = typeof ApplicationTypeEnum[keyof typeof ApplicationTypeEnum];


/**
 * 
 * @export
 * @interface ApplicationTypeEnumEnumWithDescription
 */
export interface ApplicationTypeEnumEnumWithDescription {
    /**
     * 
     * @type {ApplicationTypeEnum}
     * @memberof ApplicationTypeEnumEnumWithDescription
     */
    'value'?: ApplicationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ApplicationTypeEnumEnumWithDescription
     */
    'label'?: string | null;
}


/**
 * 
 * @export
 * @interface AssetCategoryModel
 */
export interface AssetCategoryModel {
    /**
     * 
     * @type {string}
     * @memberof AssetCategoryModel
     */
    'assetFocus'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetCategoryModel
     */
    'productId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetCategoryModel
     */
    'assetCategoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetCategoryModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetCategoryModel
     */
    'firstCreatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetCategoryModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetCategoryModel
     */
    'lastUpdatedDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetCategoryModel
     */
    'delete'?: boolean;
}
/**
 * 
 * @export
 * @interface BillingContactModel
 */
export interface BillingContactModel {
    /**
     * 
     * @type {string}
     * @memberof BillingContactModel
     */
    'billingContactId'?: string;
    /**
     * 
     * @type {number}
     * @memberof BillingContactModel
     */
    'contactId'?: number;
    /**
     * 
     * @type {ContactModel}
     * @memberof BillingContactModel
     */
    'contactModel'?: ContactModel;
    /**
     * 
     * @type {string}
     * @memberof BillingContactModel
     */
    'effectiveDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingContactModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillingContactModel
     */
    'firstCreatedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof BillingContactModel
     */
    'issuerId'?: number;
}
/**
 * 
 * @export
 * @interface ContactModel
 */
export interface ContactModel {
    /**
     * 
     * @type {Array<Address>}
     * @memberof ContactModel
     */
    'address'?: Array<Address> | null;
    /**
     * 
     * @type {string}
     * @memberof ContactModel
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactModel
     */
    'email2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactModel
     */
    'firstCreatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactModel
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContactModel
     */
    'contactId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContactModel
     */
    'isBilling'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContactModel
     */
    'isListing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContactModel
     */
    'isTechnical'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContactModel
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactModel
     */
    'lastUpdatedDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContactModel
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactModel
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactModel
     */
    'phone2'?: string | null;
    /**
     * 
     * @type {StatusBasicEnum}
     * @memberof ContactModel
     */
    'status'?: StatusBasicEnum;
    /**
     * 
     * @type {Array<IssuerModelPartial>}
     * @memberof ContactModel
     */
    'listingIssuers'?: Array<IssuerModelPartial> | null;
    /**
     * 
     * @type {Array<IssuerModelPartial>}
     * @memberof ContactModel
     */
    'billingIssuers'?: Array<IssuerModelPartial> | null;

    'isChecked' ?: boolean
}


/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * 
     * @type {Array<AdminRegion>}
     * @memberof Country
     */
    'regions'?: Array<AdminRegion> | null;
    /**
     * 
     * @type {AdminRegion}
     * @memberof Country
     */
    'selectedRegion'?: AdminRegion;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'currencyEnglishName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'currencySymbol'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'nameEnglish'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'code3CurrencyISO4217'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'code2CountryLetterIso3166'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'code3CountryLetterIso3166'?: string | null;
}
/**
 * 
 * @export
 * @interface CountryList
 */
export interface CountryList {
    /**
     * 
     * @type {Array<Country>}
     * @memberof CountryList
     */
    'countries'?: Array<Country> | null;
}
/**
 * 
 * @export
 * @interface DisplayConfiguration
 */
export interface DisplayConfiguration {
    /**
     * 
     * @type {string}
     * @memberof DisplayConfiguration
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisplayConfiguration
     */
    'shortName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisplayConfiguration
     */
    'sectionName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DisplayConfiguration
     */
    'fieldOrder'?: number;
    /**
     * 
     * @type {number}
     * @memberof DisplayConfiguration
     */
    'sectionOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof DisplayConfiguration
     */
    'defaultValue'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DisplayConfiguration
     */
    'hideIfFalseOrEmpty'?: boolean;
    /**
     * 
     * @type {UserRolesEnum}
     * @memberof DisplayConfiguration
     */
    'userRoles'?: UserRolesEnum;
    /**
     * 
     * @type {string}
     * @memberof DisplayConfiguration
     */
    'uiInput'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisplayConfiguration
     */
    'displayFormat'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof DisplayConfiguration
     */
    'conditions'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DisplayConfiguration
     */
    'cssClass'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DocumentTypeEnum = {
    Sai: 'SAI',
    Month: 'MONTH',
    Profil: 'PROFIL',
    Pstat: 'PSTAT',
    Psumm: 'PSUMM',
    Pdrft: 'PDRFT',
    Sharea: 'SHAREA',
    Shares: 'SHARES',
    Delete: 'DELETE',
    Name: 'NAME',
    Reorg: 'REORG',
    Ppm: 'PPM',
    Mkmat: 'MKMAT',
    Dctrst: 'DCTRST',
    Potna: 'POTNA',
    Sumpd: 'SUMPD',
    Other: 'OTHER',
    Kiid: 'KIID'
} as const;

export type DocumentTypeEnum = typeof DocumentTypeEnum[keyof typeof DocumentTypeEnum];


/**
 * 
 * @export
 * @interface DocumentTypeEnumEnumWithDescription
 */
export interface DocumentTypeEnumEnumWithDescription {
    /**
     * 
     * @type {DocumentTypeEnum}
     * @memberof DocumentTypeEnumEnumWithDescription
     */
    'value'?: DocumentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DocumentTypeEnumEnumWithDescription
     */
    'label'?: string | null;
}


/**
 * 
 * @export
 * @interface FileStream
 */
export interface FileStream {
    /**
     * 
     * @type {boolean}
     * @memberof FileStream
     */
    'canTimeout'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FileStream
     */
    'readTimeout'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileStream
     */
    'writeTimeout'?: number;
    /**
     * 
     * @type {object}
     * @memberof FileStream
     */
    'handle'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof FileStream
     */
    'canRead'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FileStream
     */
    'canWrite'?: boolean;
    /**
     * 
     * @type {SafeFileHandle}
     * @memberof FileStream
     */
    'safeFileHandle'?: SafeFileHandle;
    /**
     * 
     * @type {string}
     * @memberof FileStream
     */
    'name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileStream
     */
    'isAsync'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FileStream
     */
    'length'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileStream
     */
    'position'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FileStream
     */
    'canSeek'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FrequencyEnum = {
    Na: 'NA',
    I: 'I',
    D: 'D',
    Tw: 'TW',
    W: 'W',
    Tm: 'TM',
    M: 'M',
    Bm: 'BM',
    Q: 'Q',
    S: 'S',
    A: 'A',
    Aa: 'AA',
    Ty: 'TY',
    Dt: 'DT',
    O: 'O'
} as const;

export type FrequencyEnum = typeof FrequencyEnum[keyof typeof FrequencyEnum];


/**
 * 
 * @export
 * @interface HoldingModel
 */
export interface HoldingModel {
    /**
     * 
     * @type {InstrumentExternalIdentifyer}
     * @memberof HoldingModel
     */
    'instrumentExternalIdentifyer'?: InstrumentExternalIdentifyer;
    /**
     * 
     * @type {number}
     * @memberof HoldingModel
     */
    'percent'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof HoldingModel
     */
    'updateDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof HoldingModel
     */
    'securityName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HoldingModel
     */
    'assetCategory'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HoldingModel
     */
    'issuerCategory'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof HoldingModel
     */
    'holdingId'?: number;
    /**
     * 
     * @type {number}
     * @memberof HoldingModel
     */
    'productId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof HoldingModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HoldingModel
     */
    'firstCreatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof HoldingModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HoldingModel
     */
    'lastUpdatedDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof HoldingModel
     */
    'delete'?: boolean;
}
/**
 * 
 * @export
 * @interface IDescription
 */
export interface IDescription {
    /**
     * 
     * @type {string}
     * @memberof IDescription
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface InstrumentExternalIdentifyer
 */
export interface InstrumentExternalIdentifyer {
    /**
     * 
     * @type {string}
     * @memberof InstrumentExternalIdentifyer
     */
    'cusip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstrumentExternalIdentifyer
     */
    'figi'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstrumentExternalIdentifyer
     */
    'isin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstrumentExternalIdentifyer
     */
    'sedol'?: string | null;
}
/**
 * 
 * @export
 * @interface IssuerDocumentModel
 */
export interface IssuerDocumentModel {
    /**
     * 
     * @type {string}
     * @memberof IssuerDocumentModel
     */
    'documentId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerDocumentModel
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IssuerDocumentModel
     */
    'isConfidential'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IssuerDocumentModel
     */
    'externalUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerDocumentModel
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerDocumentModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerDocumentModel
     */
    'firstCreatedDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerDocumentModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerDocumentModel
     */
    'lastUpdatedDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IssuerDocumentModel
     */
    'issuerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IssuerDocumentModel
     */
    'issuerName'?: string | null;
    /**
     * 
     * @type {StatusAprovalSimplifiedEnum}
     * @memberof IssuerDocumentModel
     */
    'Status'?: StatusAprovalSimplifiedEnum;
    /**
     * 
     * @type {DocumentTypeEnum}
     * @memberof IssuerDocumentModel
     */
    'documentTypeCode'?: DocumentTypeEnum;
}


/**
 * 
 * @export
 * @interface IssuerModel
 */
export interface IssuerModel {
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'firstCreatedDate'?: string | null;
    /**
     * 
     * @type {Address}
     * @memberof IssuerModel
     */
    'headquartersLocationAddress'?: Address;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'inBusinessSince'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'investorRelationsPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'issuerCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'issuerCusip'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IssuerModel
     */
    'issuerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'issuerName': string;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'lastUpdatedDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IssuerModel
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'stageFirstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'stageFirstCreatedDate': string;
    /**
     * 
     * @type {StatusBasicEnum}
     * @memberof IssuerModel
     */
    'Status'?: StatusBasicEnum;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'totalAssetsUnderManagement'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'totalAssetsUnderManagementDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'webSite'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'investorRelationsEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'organizationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerModel
     */
    'investorInvestedAssets'?: string | null;
}


/**
 * 
 * @export
 * @interface IssuerModelPartial
 */
export interface IssuerModelPartial {
    /**
     * 
     * @type {string}
     * @memberof IssuerModelPartial
     */
    'issuerName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IssuerModelPartial
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IssuerModelPartial
     */
    'issuerId'?: number;
}
/**
 * 
 * @export
 * @interface IssuerStageModel
 */
export interface IssuerStageModel {
    /**
     * 
     * @type {string}
     * @memberof IssuerStageModel
     */
    'organizationStageId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerStageModel
     */
    'firstCreatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof IssuerStageModel
     */
    'firstCreatedDate': string;
    /**
     * 
     * @type {string}
     * @memberof IssuerStageModel
     */
    'issuerName': string;
    /**
     * 
     * @type {string}
     * @memberof IssuerStageModel
     */
    'issuerStageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof IssuerStageModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IssuerStageModel
     */
    'lastUpdatedDate'?: string | null;
}
/**
 * 
 * @export
 * @interface ListingContactModel
 */
export interface ListingContactModel {
    /**
     * 
     * @type {number}
     * @memberof ListingContactModel
     */
    'contactId'?: number;
    /**
     * 
     * @type {ContactModel}
     * @memberof ListingContactModel
     */
    'contactModel'?: ContactModel;
    /**
     * 
     * @type {string}
     * @memberof ListingContactModel
     */
    'listingContactId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ListingContactModel
     */
    'deleted'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListingContactModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListingContactModel
     */
    'firstCreatedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ListingContactModel
     */
    'issuerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ListingContactModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListingContactModel
     */
    'lastUpdatedDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ListingContactModel
     */
    'live'?: number;
    /**
     * 
     * @type {number}
     * @memberof ListingContactModel
     */
    'pending'?: number;
}
/**
 * 
 * @export
 * @interface LoginAccessKey
 */
export interface LoginAccessKey {
    /**
     * 
     * @type {string}
     * @memberof LoginAccessKey
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginAccessKey
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginAccessKey
     */
    'accessKey'?: string | null;
}
/**
 * 
 * @export
 * @interface LoginTotp
 */
export interface LoginTotp {
    /**
     * 
     * @type {string}
     * @memberof LoginTotp
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginTotp
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginTotp
     */
    'totp'?: string | null;
}
/**
 * 
 * @export
 * @interface ManagmentModel
 */
export interface ManagmentModel {
    /**
     * Fund Manager Name
     * @type {string}
     * @memberof ManagmentModel
     */
    'fundManager'?: string | null;
    /**
     * Management Tenure
     * @type {number}
     * @memberof ManagmentModel
     */
    'managementTenure'?: number | null;
    /**
     * Fund Manager Start Date
     * @type {string}
     * @memberof ManagmentModel
     */
    'fundManagerStartDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ManagmentModel
     */
    'managementId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManagmentModel
     */
    'productId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ManagmentModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManagmentModel
     */
    'firstCreatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagmentModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManagmentModel
     */
    'lastUpdatedDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ManagmentModel
     */
    'delete'?: boolean;
}
/**
 * 
 * @export
 * @interface MenuSection
 */
export interface MenuSection {
    /**
     * 
     * @type {string}
     * @memberof MenuSection
     */
    'key'?: string | null;
    /**
     * 
     * @type {Array<RouteElement>}
     * @memberof MenuSection
     */
    'routeElements'?: Array<RouteElement> | null;
    /**
     * 
     * @type {string}
     * @memberof MenuSection
     */
    'title'?: string | null;
}
/**
 * 
 * @export
 * @interface ModelSettings
 */
export interface ModelSettings {
    /**
     * 
     * @type {string}
     * @memberof ModelSettings
     */
    'fieldName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ModelSettings
     */
    'fieldType'?: string | null;
    /**
     * 
     * @type {DisplayConfiguration}
     * @memberof ModelSettings
     */
    'displayConfiguration'?: DisplayConfiguration;
    /**
     * 
     * @type {Array<Rule>}
     * @memberof ModelSettings
     */
    'settings'?: Array<Rule> | null;
}
/**
 * 
 * @export
 * @interface NfnToken
 */
export interface NfnToken {
    /**
     * 
     * @type {string}
     * @memberof NfnToken
     */
    'data'?: string | null;
}
/**
 * 
 * @export
 * @interface NoContentResult
 */
export interface NoContentResult {
    /**
     * 
     * @type {number}
     * @memberof NoContentResult
     */
    'statusCode'?: number;
}
/**
 * 
 * @export
 * @interface NwsfUserInfoModel
 */
export interface NwsfUserInfoModel {
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'corpEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'csmpid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'department'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'errorMessage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'fcd'?: string;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'lud'?: string;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'orgName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'requestDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'screenName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'roles'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'userFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'userLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NwsfUserInfoModel
     */
    'zip'?: string | null;
}
/**
 * 
 * @export
 * @interface OrganizationIssuerRelationModel
 */
export interface OrganizationIssuerRelationModel {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIssuerRelationModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIssuerRelationModel
     */
    'firstCreatedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationIssuerRelationModel
     */
    'issuerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIssuerRelationModel
     */
    'issuerName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIssuerRelationModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIssuerRelationModel
     */
    'lastUpdatedDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationIssuerRelationModel
     */
    'management'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrganizationIssuerRelationModel
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIssuerRelationModel
     */
    'organizationIssuerRelationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIssuerRelationModel
     */
    'organizationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationIssuerRelationModel
     */
    'mpid'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationIssuerRelationModel
     */
    'price'?: boolean;
    /**
     * 
     * @type {StatusBasicEnum}
     * @memberof OrganizationIssuerRelationModel
     */
    'Status'?: StatusBasicEnum;
}


/**
 * 
 * @export
 * @interface OrganizationIssuerRelationModelPartial
 */
export interface OrganizationIssuerRelationModelPartial {
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationIssuerRelationModelPartial
     */
    'price'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationIssuerRelationModelPartial
     */
    'management'?: boolean;
    /**
     * 
     * @type {StatusBasicEnum}
     * @memberof OrganizationIssuerRelationModelPartial
     */
    'status'?: StatusBasicEnum;
    /**
     * 
     * @type {number}
     * @memberof OrganizationIssuerRelationModelPartial
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationIssuerRelationModelPartial
     */
    'issuerId'?: number;
}


/**
 * 
 * @export
 * @interface OrganizationIssuerSearchParams
 */
export interface OrganizationIssuerSearchParams {
    /**
     * 
     * @type {string}
     * @memberof OrganizationIssuerSearchParams
     */
    'searchString'?: string | null;
    /**
     * 
     * @type {SearchType}
     * @memberof OrganizationIssuerSearchParams
     */
    'searchType'?: SearchType;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationIssuerSearchParams
     */
    'price'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationIssuerSearchParams
     */
    'active'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationIssuerSearchParams
     */
    'pageSize'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationIssuerSearchParams
     */
    'pageNumber'?: number | null;
}


/**
 * 
 * @export
 * @interface OrganizationModel
 */
export interface OrganizationModel {
    /**
     * 
     * @type {string}
     * @memberof OrganizationModel
     */
    'approvedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationModel
     */
    'approvedDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationModel
     */
    'financeHold'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationModel
     */
    'firstCreatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationModel
     */
    'lastUpdatedDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationModel
     */
    'mpid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationModel
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationModel
     */
    'organizationName': string;
    /**
     * 
     * @type {StatusBasicEnum}
     * @memberof OrganizationModel
     */
    'status'?: StatusBasicEnum;
    /**
     * 
     * @type {Country}
     * @memberof OrganizationModel
     */
    'countryOfOperation'?: Country;
}


/**
 * 
 * @export
 * @interface OrganizationStageModel
 */
export interface OrganizationStageModel {
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModel
     */
    'firstCreatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModel
     */
    'firstCreatedDate': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModel
     */
    'lastUpdatedDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModel
     */
    'mpid'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationStageModel
     */
    'mpidRequested'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrganizationStageModel
     */
    'organizationId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModel
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModel
     */
    'organizationStageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModel
     */
    'signatoryEmail': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModel
     */
    'signatoryFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModel
     */
    'signatoryLastName': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModel
     */
    'signatoryTitle'?: string | null;
    /**
     * 
     * @type {Country}
     * @memberof OrganizationStageModel
     */
    'countryOfOperation'?: Country;
}
/**
 * 
 * @export
 * @interface OrganizationStageModelPartial
 */
export interface OrganizationStageModelPartial {
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModelPartial
     */
    'signatoryFirstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModelPartial
     */
    'signatoryLastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModelPartial
     */
    'signatoryTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModelPartial
     */
    'signatoryEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModelPartial
     */
    'organizationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageModelPartial
     */
    'mpid'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationStageModelPartial
     */
    'mpidRequested'?: boolean;
    /**
     * 
     * @type {Country}
     * @memberof OrganizationStageModelPartial
     */
    'countryOfOperation'?: Country;
}
/**
 * 
 * @export
 * @interface OrganizationStageProcessModel
 */
export interface OrganizationStageProcessModel {
    /**
     * 
     * @type {string}
     * @memberof OrganizationStageProcessModel
     */
    'organizationRejectionReason'?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof OrganizationStageProcessModel
     */
    'rejectedIssuers'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface OrganizationUserModel
 */
export interface OrganizationUserModel {
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserModel
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserModel
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationUserModel
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserModel
     */
    'primaryEmail'?: string | null;
    /**
     * 
     * @type {UserRolesEnum}
     * @memberof OrganizationUserModel
     */
    'roleCodes'?: UserRolesEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserModel
     */
    'secondaryEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserModel
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserModel
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserModel
     */
    'firstCreatedDate'?: string;
}


/**
 * 
 * @export
 * @interface PortfolioAllocationModel
 */
export interface PortfolioAllocationModel {
    /**
     * 
     * @type {number}
     * @memberof PortfolioAllocationModel
     */
    'portfolioAllocationId'?: number;
    /**
     * 
     * @type {PortfolioAllocationType}
     * @memberof PortfolioAllocationModel
     */
    'portfolioAllocationType'?: PortfolioAllocationType;
    /**
     * 
     * @type {number}
     * @memberof PortfolioAllocationModel
     */
    'productId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PortfolioAllocationModel
     */
    'allocation'?: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioAllocationModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortfolioAllocationModel
     */
    'firstCreatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioAllocationModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortfolioAllocationModel
     */
    'lastUpdatedDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioAllocationModel
     */
    'delete'?: boolean;
}
/**
 * 
 * @export
 * @interface PortfolioAllocationType
 */
export interface PortfolioAllocationType {
    /**
     * 
     * @type {number}
     * @memberof PortfolioAllocationType
     */
    'portfolioAllocationTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioAllocationType
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortfolioAllocationType
     */
    'groupName'?: string | null;
}
/**
 * 
 * @export
 * @interface ProductModel
 */
export interface ProductModel {
    /**
     * 
     * @type {number}
     * @memberof ProductModel
     */
    'productId'?: number;
    /**
     * 
     * @type {StatusAprovalSimplifiedEnum}
     * @memberof ProductModel
     */
    'status'?: StatusAprovalSimplifiedEnum;
    /**
     * 
     * @type {ProductTypeEnum}
     * @memberof ProductModel
     */
    'productType'?: ProductTypeEnum;
    /**
     * Product Symbol
     * @type {string}
     * @memberof ProductModel
     */
    'productSymbol'?: string | null;
    /**
     * Issuer Name
     * @type {string}
     * @memberof ProductModel
     */
    'issuerName'?: string | null;
    /**
     * Issuer Code
     * @type {string}
     * @memberof ProductModel
     */
    'issuerCode'?: string | null;
    /**
     * Issuer Name
     * @type {number}
     * @memberof ProductModel
     */
    'issuerId'?: number;
    /**
     * SEC Series
     * @type {string}
     * @memberof ProductModel
     */
    'secSeries'?: string | null;
    /**
     * Product Name
     * @type {string}
     * @memberof ProductModel
     */
    'productName'?: string | null;
    /**
     * Product Website
     * @type {string}
     * @memberof ProductModel
     */
    'productWebSite'?: string | null;
    /**
     * Asset Category
     * @type {Array<AssetCategoryModel>}
     * @memberof ProductModel
     */
    'assetCategory'?: Array<AssetCategoryModel> | null;
    /**
     * Investment Type and Style
     * @type {string}
     * @memberof ProductModel
     */
    'assetSizeMarketCap'?: string | null;
    /**
     * Economic Development
     * @type {string}
     * @memberof ProductModel
     */
    'economicDevelopment'?: string | null;
    /**
     * Sector
     * @type {string}
     * @memberof ProductModel
     */
    'equitySingleSector'?: string | null;
    /**
     * Weighting Method
     * @type {string}
     * @memberof ProductModel
     */
    'factorWeightingScheme'?: string | null;
    /**
     * Credit Quality
     * @type {string}
     * @memberof ProductModel
     */
    'fixedIncomeValuationCreditQuality'?: string | null;
    /**
     * Maturity Range
     * @type {string}
     * @memberof ProductModel
     */
    'fixedIncomeValuationMaturityPeriod'?: string | null;
    /**
     * Fund Investment Category
     * @type {string}
     * @memberof ProductModel
     */
    'fundInvestmentCategory'?: string | null;
    /**
     * Industry
     * @type {string}
     * @memberof ProductModel
     */
    'industryAlignment'?: string | null;
    /**
     * Leverage Amount Limits
     * @type {number}
     * @memberof ProductModel
     */
    'leverageAmountLimits'?: number | null;
    /**
     * Liquidity Category
     * @type {string}
     * @memberof ProductModel
     */
    'liquidityCategory'?: string | null;
    /**
     * Macro Region
     * @type {string}
     * @memberof ProductModel
     */
    'macroRegion'?: string | null;
    /**
     * Portfolio Management Style
     * @type {string}
     * @memberof ProductModel
     */
    'managementStyle'?: string | null;
    /**
     * Benchmark1
     * @type {string}
     * @memberof ProductModel
     */
    'benchmark1'?: string | null;
    /**
     * Benchmark2
     * @type {string}
     * @memberof ProductModel
     */
    'benchmark2'?: string | null;
    /**
     * Benchmark3
     * @type {string}
     * @memberof ProductModel
     */
    'benchmark3'?: string | null;
    /**
     * Benchmark 1 Percentage
     * @type {number}
     * @memberof ProductModel
     */
    'benchmark1Percentage'?: number | null;
    /**
     * Benchmark 2 Percentage
     * @type {number}
     * @memberof ProductModel
     */
    'benchmark2Percentage'?: number | null;
    /**
     * Benchmark 3 Percentage
     * @type {number}
     * @memberof ProductModel
     */
    'benchmark3Percentage'?: number | null;
    /**
     * Portfolio Type
     * @type {string}
     * @memberof ProductModel
     */
    'portfolioType'?: string | null;
    /**
     * Investment Focus
     * @type {string}
     * @memberof ProductModel
     */
    'investmentFocus'?: string | null;
    /**
     * Peer Group
     * @type {string}
     * @memberof ProductModel
     */
    'peerGroup'?: string | null;
    /**
     * Portfolio Top Holdings2
     * @type {Array<HoldingModel>}
     * @memberof ProductModel
     */
    'holdings'?: Array<HoldingModel> | null;
    /**
     * Strategy Inception Date
     * @type {string}
     * @memberof ProductModel
     */
    'strategyInceptionDate'?: string | null;
    /**
     * 
     * @type {FrequencyEnum}
     * @memberof ProductModel
     */
    'seriesOfferingFrequency'?: FrequencyEnum;
    /**
     * Portfolio Supervisor
     * @type {string}
     * @memberof ProductModel
     */
    'portfolioSupervisor'?: string | null;
    /**
     * Portfolio Sub Advisor
     * @type {string}
     * @memberof ProductModel
     */
    'portfolioSubAdvisor'?: string | null;
    /**
     * 
     * @type {TaxStructureEnum}
     * @memberof ProductModel
     */
    'taxStructure'?: TaxStructureEnum;
    /**
     * Objective
     * @type {string}
     * @memberof ProductModel
     */
    'objective'?: string | null;
    /**
     * Investment Description
     * @type {string}
     * @memberof ProductModel
     */
    'investmentDescription'?: string | null;
    /**
     * Total Real Estate Area
     * @type {number}
     * @memberof ProductModel
     */
    'totalRealEstateArea'?: number | null;
    /**
     * 
     * @type {UnitOfMeasurementEnum}
     * @memberof ProductModel
     */
    'unitOfMeasurement'?: UnitOfMeasurementEnum;
    /**
     * Real Estate Portfolio Occupancy
     * @type {number}
     * @memberof ProductModel
     */
    'realEstateProtfolioOccupancy'?: number | null;
    /**
     * Real Estate Portfolio Occupancy Date
     * @type {string}
     * @memberof ProductModel
     */
    'realEstateProtfolioOccupancyDate'?: string | null;
    /**
     * Zero Redemption
     * @type {boolean}
     * @memberof ProductModel
     */
    'zeroRedemption'?: boolean | null;
    /**
     * Zero Redemption Months
     * @type {number}
     * @memberof ProductModel
     */
    'zeroRedemptionMonths'?: number | null;
    /**
     * Zero Redemption Fee
     * @type {number}
     * @memberof ProductModel
     */
    'zeroRedemptionFee'?: number | null;
    /**
     * Early Redemption Term
     * @type {boolean}
     * @memberof ProductModel
     */
    'earlyRedemptionTerm'?: boolean | null;
    /**
     * Early Redemption Term Fee
     * @type {number}
     * @memberof ProductModel
     */
    'earlyRedemptionTermFee'?: number | null;
    /**
     * Early Redemption Start Month
     * @type {number}
     * @memberof ProductModel
     */
    'earlyRedemptionTermStartMonth'?: number | null;
    /**
     * Early Redemption End Month
     * @type {number}
     * @memberof ProductModel
     */
    'earlyRedemptionTermEndMonth'?: number | null;
    /**
     * Tiered Redemption
     * @type {boolean}
     * @memberof ProductModel
     */
    'tieredRedemption'?: boolean | null;
    /**
     * Tiered Redemption Term Fee
     * @type {number}
     * @memberof ProductModel
     */
    'tieredRedemptionTermFee'?: number | null;
    /**
     * Tiered Redemption Start Month
     * @type {number}
     * @memberof ProductModel
     */
    'tieredRedemptionTermStartMonth'?: number | null;
    /**
     * Tiered Redemption End Month
     * @type {number}
     * @memberof ProductModel
     */
    'tieredRedemptionTermEndMonth'?: number | null;
    /**
     * Full Redemption Month
     * @type {number}
     * @memberof ProductModel
     */
    'fullRedemptionMonth'?: number | null;
    /**
     * Up Front Commission
     * @type {number}
     * @memberof ProductModel
     */
    'upFrontCommission'?: number | null;
    /**
     * Trailing Commission
     * @type {number}
     * @memberof ProductModel
     */
    'trailingCommission'?: number | null;
    /**
     * Management Oversight
     * @type {string}
     * @memberof ProductModel
     */
    'managementOversight'?: string | null;
    /**
     * Non-Traded REIT Structure
     * @type {string}
     * @memberof ProductModel
     */
    'nonTradedReitStructure'?: string | null;
    /**
     * Investor Suitability
     * @type {string}
     * @memberof ProductModel
     */
    'investorSuitability'?: string | null;
    /**
     * Legal Form
     * @type {string}
     * @memberof ProductModel
     */
    'legalFormId'?: string | null;
    /**
     * Portfolio Currency Hedge
     * @type {string}
     * @memberof ProductModel
     */
    'portfolioCurrencyHedge'?: string | null;
    /**
     * Has Country Paying Agent
     * @type {boolean}
     * @memberof ProductModel
     */
    'hasCountryPayingAgent'?: boolean;
    /**
     * Is EU Directive Relevant
     * @type {boolean}
     * @memberof ProductModel
     */
    'isEuDirectiveRelevant'?: boolean;
    /**
     * Type of EU Directive
     * @type {string}
     * @memberof ProductModel
     */
    'kneipTypeOfEuDirective'?: string | null;
    /**
     * Is UK Offshore Fund Authorised By FCA
     * @type {boolean}
     * @memberof ProductModel
     */
    'isUkOffshoreFundAuthorizedByFca'?: boolean;
    /**
     * Is UK Offshore Fund Recognized By FCA
     * @type {boolean}
     * @memberof ProductModel
     */
    'isUKOffshoreFundRecognizedByFCA'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'firstCreatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    'lastUpdatedDate'?: string | null;
    /**
     * Region Weight
     * @type {Array<RegionWeightModel>}
     * @memberof ProductModel
     */
    'regionWeights'?: Array<RegionWeightModel> | null;
    /**
     * Managment
     * @type {Array<ManagmentModel>}
     * @memberof ProductModel
     */
    'managments'?: Array<ManagmentModel> | null;
    /**
     * Portfolio Allocation
     * @type {Array<PortfolioAllocationModel>}
     * @memberof ProductModel
     */
    'portfolioAllocations'?: Array<PortfolioAllocationModel> | null;
    /**
     * Country Of Sale
     * @type {Array<Country>}
     * @memberof ProductModel
     */
    'countryOfSale'?: Array<Country> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductModel
     */
    'excludeFromDistribution'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProductTypeEnum = {
    General: 'GENERAL',
    Uit: 'UIT',
    Reit: 'REIT',
    Ucits: 'UCITS',
    Distribution: 'Distribution',
    Sp: 'SP'
} as const;

export type ProductTypeEnum = typeof ProductTypeEnum[keyof typeof ProductTypeEnum];


/**
 * 
 * @export
 * @interface ProductTypeEnumEnumWithDescription
 */
export interface ProductTypeEnumEnumWithDescription {
    /**
     * 
     * @type {ProductTypeEnum}
     * @memberof ProductTypeEnumEnumWithDescription
     */
    'value'?: ProductTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductTypeEnumEnumWithDescription
     */
    'label'?: string | null;
}


/**
 * 
 * @export
 * @interface Region
 */
export interface Region {
    /**
     * 
     * @type {string}
     * @memberof Region
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Region
     */
    'regionId'?: number;
}
/**
 * 
 * @export
 * @interface RegionWeightModel
 */
export interface RegionWeightModel {
    /**
     * 
     * @type {Region}
     * @memberof RegionWeightModel
     */
    'region'?: Region;
    /**
     * 
     * @type {number}
     * @memberof RegionWeightModel
     */
    'productId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RegionWeightModel
     */
    'regionWeightValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RegionWeightModel
     */
    'regionWeightId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RegionWeightModel
     */
    'firstCreatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegionWeightModel
     */
    'firstCreatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegionWeightModel
     */
    'lastUpdatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegionWeightModel
     */
    'lastUpdatedDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RegionWeightModel
     */
    'delete'?: boolean;
}
/**
 * 
 * @export
 * @interface RouteElement
 */
export interface RouteElement {
    /**
     * 
     * @type {string}
     * @memberof RouteElement
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RouteElement
     */
    'title'?: string | null;
    /**
     * 
     * @type {Array<MenuSection>}
     * @memberof RouteElement
     */
    'menuSubSections'?: Array<MenuSection> | null;
}
/**
 * 
 * @export
 * @interface Rule
 */
export interface Rule {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Rule
     */
    'conditions'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    'regExPattern'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    'apiValidator'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    'uiRule'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    'errorMessage'?: string | null;
}
/**
 * 
 * @export
 * @interface SafeFileHandle
 */
export interface SafeFileHandle {
    /**
     * 
     * @type {boolean}
     * @memberof SafeFileHandle
     */
    'isClosed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafeFileHandle
     */
    'isAsync'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafeFileHandle
     */
    'isInvalid'?: boolean;
}
/**
 * used to specify search type for string searches
 * @export
 * @enum {string}
 */

export const SearchType = {
    StartsWith: 'StartsWith',
    Contains: 'Contains'
} as const;

export type SearchType = typeof SearchType[keyof typeof SearchType];


/**
 * 
 * @export
 * @enum {string}
 */

export const StatusAprovalSimplifiedEnum = {
    None: 'None',
    Pending: 'Pending',
    Active: 'Active',
    Inactive: 'Inactive'
} as const;

export type StatusAprovalSimplifiedEnum = typeof StatusAprovalSimplifiedEnum[keyof typeof StatusAprovalSimplifiedEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const StatusBasicEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;

export type StatusBasicEnum = typeof StatusBasicEnum[keyof typeof StatusBasicEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const TaxStructureEnum = {
    R: 'R',
    G: 'G'
} as const;

export type TaxStructureEnum = typeof TaxStructureEnum[keyof typeof TaxStructureEnum];


/**
 * 
 * @export
 * @interface UiRoutes
 */
export interface UiRoutes {
    /**
     * One or many Menu sections to render top menu elements such as Instruments, supervisory, downloads etc
     * @type {Array<MenuSection>}
     * @memberof UiRoutes
     */
    'menuSections'?: Array<MenuSection> | null;
    /**
     * used to create stand alone UI elements wich are not added to menu  Internal links withing UI
     * @type {Array<RouteElement>}
     * @memberof UiRoutes
     */
    'routeElements'?: Array<RouteElement> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UiRoutes
     */
    'allKeys'?: Array<string> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UnitOfMeasurementEnum = {
    Na: 'NA',
    Sqft: 'SQFT',
    Sqmt: 'SQMT'
} as const;

export type UnitOfMeasurementEnum = typeof UnitOfMeasurementEnum[keyof typeof UnitOfMeasurementEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const UserRolesEnum = {
    None: 'None',
    Supervisor: 'Supervisor',
    CategoryUpdate: 'CategoryUpdate',
    GlobalFundCount: 'GlobalFundCount',
    GlobalFundCountRestricted: 'GlobalFundCountRestricted',
    Ctci: 'CTCI',
    Mfundftp: 'MFUNDFTP',
    Standard: 'Standard',
    FirmAdmin: 'FirmAdmin',
    ViewOnly: 'ViewOnly',
    Vendor: 'Vendor',
    PricingAgent: 'PricingAgent',
    VendorNoCusip: 'VendorNoCUSIP',
    Navcusip: 'NAVCUSIP',
    NavnoCusip: 'NAVNoCUSIP',
    DlDirectoryLevel2: 'DlDirectoryLevel2',
    Root: 'Root',
    DlDirectoryLevel3: 'DlDirectoryLevel3',
    PriceNoBill: 'PriceNoBill',
    All: 'All'
} as const;

export type UserRolesEnum = typeof UserRolesEnum[keyof typeof UserRolesEnum];



/**
 * AuthenticateApi - axios parameter creator
 * @export
 */
export const AuthenticateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Used for user authentication. requires user name, password and totp
         * @param {LoginTotp} [loginTotp] {\&quot;userName\&quot;:\&quot;john\&quot;,\&quot;password\&quot;:\&quot;secret123\&quot;, \&quot;totp\&quot;:\&quot;543566\&quot;}
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticateAuthenticatePost: async (loginTotp?: LoginTotp, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authenticate/authenticate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginTotp, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns allowed routes for annonymus or authorized user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticateGetRoutesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authenticate/GetRoutes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Current Build Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticateGetvGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authenticate/getv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invalidates Session Cookie and user sessiont. JWT will expire on its own.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticateLogoutPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authenticate/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary used to refresh JWT token for sliding expiration.  User needs to be authenticated and Original JWT passed in  Authorization header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticateRefreshtokenPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authenticate/refreshtoken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Future use, Not Implemented
         * @param {LoginAccessKey} [loginAccessKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticateTempsessionPost: async (loginAccessKey?: LoginAccessKey, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Authenticate/tempsession`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginAccessKey, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticateApi - functional programming interface
 * @export
 */
export const AuthenticateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Used for user authentication. requires user name, password and totp
         * @param {LoginTotp} [loginTotp] {\&quot;userName\&quot;:\&quot;john\&quot;,\&quot;password\&quot;:\&quot;secret123\&quot;, \&quot;totp\&quot;:\&quot;543566\&quot;}
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticateAuthenticatePost(loginTotp?: LoginTotp, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NfnToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticateAuthenticatePost(loginTotp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary returns allowed routes for annonymus or authorized user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticateGetRoutesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UiRoutes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticateGetRoutesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Current Build Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticateGetvGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticateGetvGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Invalidates Session Cookie and user sessiont. JWT will expire on its own.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticateLogoutPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoContentResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticateLogoutPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary used to refresh JWT token for sliding expiration.  User needs to be authenticated and Original JWT passed in  Authorization header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticateRefreshtokenPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NfnToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticateRefreshtokenPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Future use, Not Implemented
         * @param {LoginAccessKey} [loginAccessKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthenticateTempsessionPost(loginAccessKey?: LoginAccessKey, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthenticateTempsessionPost(loginAccessKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthenticateApi - factory interface
 * @export
 */
export const AuthenticateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticateApiFp(configuration)
    return {
        /**
         * 
         * @summary Used for user authentication. requires user name, password and totp
         * @param {LoginTotp} [loginTotp] {\&quot;userName\&quot;:\&quot;john\&quot;,\&quot;password\&quot;:\&quot;secret123\&quot;, \&quot;totp\&quot;:\&quot;543566\&quot;}
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticateAuthenticatePost(loginTotp?: LoginTotp, options?: any): AxiosPromise<NfnToken> {
            return localVarFp.apiAuthenticateAuthenticatePost(loginTotp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns allowed routes for annonymus or authorized user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticateGetRoutesGet(options?: any): AxiosPromise<UiRoutes> {
            return localVarFp.apiAuthenticateGetRoutesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Current Build Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticateGetvGet(options?: any): AxiosPromise<string> {
            return localVarFp.apiAuthenticateGetvGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invalidates Session Cookie and user sessiont. JWT will expire on its own.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticateLogoutPost(options?: any): AxiosPromise<NoContentResult> {
            return localVarFp.apiAuthenticateLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary used to refresh JWT token for sliding expiration.  User needs to be authenticated and Original JWT passed in  Authorization header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticateRefreshtokenPost(options?: any): AxiosPromise<NfnToken> {
            return localVarFp.apiAuthenticateRefreshtokenPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Future use, Not Implemented
         * @param {LoginAccessKey} [loginAccessKey] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthenticateTempsessionPost(loginAccessKey?: LoginAccessKey, options?: any): AxiosPromise<void> {
            return localVarFp.apiAuthenticateTempsessionPost(loginAccessKey, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticateApi - interface
 * @export
 * @interface AuthenticateApi
 */
export interface AuthenticateApiInterface {
    /**
     * 
     * @summary Used for user authentication. requires user name, password and totp
     * @param {LoginTotp} [loginTotp] {\&quot;userName\&quot;:\&quot;john\&quot;,\&quot;password\&quot;:\&quot;secret123\&quot;, \&quot;totp\&quot;:\&quot;543566\&quot;}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApiInterface
     */
    apiAuthenticateAuthenticatePost(loginTotp?: LoginTotp, options?: AxiosRequestConfig): AxiosPromise<NfnToken>;

    /**
     * 
     * @summary returns allowed routes for annonymus or authorized user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApiInterface
     */
    apiAuthenticateGetRoutesGet(options?: AxiosRequestConfig): AxiosPromise<UiRoutes>;

    /**
     * 
     * @summary Current Build Version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApiInterface
     */
    apiAuthenticateGetvGet(options?: AxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Invalidates Session Cookie and user sessiont. JWT will expire on its own.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApiInterface
     */
    apiAuthenticateLogoutPost(options?: AxiosRequestConfig): AxiosPromise<NoContentResult>;

    /**
     * 
     * @summary used to refresh JWT token for sliding expiration.  User needs to be authenticated and Original JWT passed in  Authorization header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApiInterface
     */
    apiAuthenticateRefreshtokenPost(options?: AxiosRequestConfig): AxiosPromise<NfnToken>;

    /**
     * 
     * @summary Future use, Not Implemented
     * @param {LoginAccessKey} [loginAccessKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApiInterface
     */
    apiAuthenticateTempsessionPost(loginAccessKey?: LoginAccessKey, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * AuthenticateApi - object-oriented interface
 * @export
 * @class AuthenticateApi
 * @extends {BaseAPI}
 */
export class AuthenticateApi extends BaseAPI implements AuthenticateApiInterface {
    /**
     * 
     * @summary Used for user authentication. requires user name, password and totp
     * @param {LoginTotp} [loginTotp] {\&quot;userName\&quot;:\&quot;john\&quot;,\&quot;password\&quot;:\&quot;secret123\&quot;, \&quot;totp\&quot;:\&quot;543566\&quot;}
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApi
     */
    public apiAuthenticateAuthenticatePost(loginTotp?: LoginTotp, options?: AxiosRequestConfig) {
        return AuthenticateApiFp(this.configuration).apiAuthenticateAuthenticatePost(loginTotp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns allowed routes for annonymus or authorized user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApi
     */
    public apiAuthenticateGetRoutesGet(options?: AxiosRequestConfig) {
        return AuthenticateApiFp(this.configuration).apiAuthenticateGetRoutesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Current Build Version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApi
     */
    public apiAuthenticateGetvGet(options?: AxiosRequestConfig) {
        return AuthenticateApiFp(this.configuration).apiAuthenticateGetvGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invalidates Session Cookie and user sessiont. JWT will expire on its own.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApi
     */
    public apiAuthenticateLogoutPost(options?: AxiosRequestConfig) {
        return AuthenticateApiFp(this.configuration).apiAuthenticateLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary used to refresh JWT token for sliding expiration.  User needs to be authenticated and Original JWT passed in  Authorization header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApi
     */
    public apiAuthenticateRefreshtokenPost(options?: AxiosRequestConfig) {
        return AuthenticateApiFp(this.configuration).apiAuthenticateRefreshtokenPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Future use, Not Implemented
     * @param {LoginAccessKey} [loginAccessKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticateApi
     */
    public apiAuthenticateTempsessionPost(loginAccessKey?: LoginAccessKey, options?: AxiosRequestConfig) {
        return AuthenticateApiFp(this.configuration).apiAuthenticateTempsessionPost(loginAccessKey, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IssuerDocumentApi - axios parameter creator
 * @export
 */
export const IssuerDocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentDocumentIdDelete: async (documentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiIssuerDocumentDocumentIdDelete', 'documentId', documentId)
            const localVarPath = `/api/IssuerDocument/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates Specific IssuerDocumdent STATUS
         * @param {string} documentId 
         * @param {StatusAprovalSimplifiedEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentDocumentIdPatch: async (documentId: string, status?: StatusAprovalSimplifiedEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiIssuerDocumentDocumentIdPatch', 'documentId', documentId)
            const localVarPath = `/api/IssuerDocument/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets user agreement for specific organization
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentDownloadDocumentIdGet: async (documentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('apiIssuerDocumentDownloadDocumentIdGet', 'documentId', documentId)
            const localVarPath = `/api/IssuerDocument/download/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * issuerid required for internal users, in all other users it will be ignored
         * @summary returns list of documents avaialble to user.
         * @param {number} issuerid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentIssuerIssueridGet: async (issuerid: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerid' is not null or undefined
            assertParamExists('apiIssuerDocumentIssuerIssueridGet', 'issuerid', issuerid)
            const localVarPath = `/api/IssuerDocument/issuer/{issuerid}`
                .replace(`{${"issuerid"}}`, encodeURIComponent(String(issuerid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns List Of pending Documents available to user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentPendingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/IssuerDocument/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary creates a new document
         * @param {string} [documentId] 
         * @param {string} [fileName] 
         * @param {boolean} [isConfidential] 
         * @param {string} [externalUrl] 
         * @param {string} [comment] 
         * @param {string} [firstCreatedBy] 
         * @param {string} [firstCreatedDate] 
         * @param {string} [lastUpdatedBy] 
         * @param {string} [lastUpdatedDate] 
         * @param {number} [issuerId] 
         * @param {string} [issuerName] 
         * @param {StatusAprovalSimplifiedEnum} [status] 
         * @param {DocumentTypeEnum} [documentTypeCode] 
         * @param {File} [formFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentPost: async (documentId?: string, fileName?: string, isConfidential?: boolean, externalUrl?: string, comment?: string, firstCreatedBy?: string, firstCreatedDate?: string, lastUpdatedBy?: string, lastUpdatedDate?: string, issuerId?: number, issuerName?: string, status?: StatusAprovalSimplifiedEnum, documentTypeCode?: DocumentTypeEnum, formFile?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/IssuerDocument`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (documentId !== undefined) { 
                localVarFormParams.append('DocumentId', documentId as any);
            }
    
            if (fileName !== undefined) { 
                localVarFormParams.append('FileName', fileName as any);
            }
    
            if (isConfidential !== undefined) { 
                localVarFormParams.append('IsConfidential', isConfidential as any);
            }
    
            if (externalUrl !== undefined) { 
                localVarFormParams.append('ExternalUrl', externalUrl as any);
            }
    
            if (comment !== undefined) { 
                localVarFormParams.append('Comment', comment as any);
            }
    
            if (firstCreatedBy !== undefined) { 
                localVarFormParams.append('FirstCreatedBy', firstCreatedBy as any);
            }
    
            if (firstCreatedDate !== undefined) { 
                localVarFormParams.append('FirstCreatedDate', firstCreatedDate as any);
            }
    
            if (lastUpdatedBy !== undefined) { 
                localVarFormParams.append('LastUpdatedBy', lastUpdatedBy as any);
            }
    
            if (lastUpdatedDate !== undefined) { 
                localVarFormParams.append('LastUpdatedDate', lastUpdatedDate as any);
            }
    
            if (issuerId !== undefined) { 
                localVarFormParams.append('IssuerId', issuerId as any);
            }
    
            if (issuerName !== undefined) { 
                localVarFormParams.append('IssuerName', issuerName as any);
            }
    
            if (status !== undefined) { 
                localVarFormParams.append('Status',status as any);
            }
    
            if (documentTypeCode !== undefined) { 
                localVarFormParams.append('DocumentTypeCode', documentTypeCode as any);
            }
    
            if (formFile !== undefined) { 
                localVarFormParams.append('formFile', formFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates Specific IssuerDocument
         * @param {IssuerDocumentModel} [issuerDocumentModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentUpdatePut: async (issuerDocumentModel?: IssuerDocumentModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/IssuerDocument/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(issuerDocumentModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IssuerDocumentApi - functional programming interface
 * @export
 */
export const IssuerDocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IssuerDocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuerDocumentDocumentIdDelete(documentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssuerDocumentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuerDocumentDocumentIdDelete(documentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates Specific IssuerDocumdent STATUS
         * @param {string} documentId 
         * @param {StatusAprovalSimplifiedEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuerDocumentDocumentIdPatch(documentId: string, status?: StatusAprovalSimplifiedEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssuerDocumentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuerDocumentDocumentIdPatch(documentId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets user agreement for specific organization
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuerDocumentDownloadDocumentIdGet(documentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStream>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuerDocumentDownloadDocumentIdGet(documentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * issuerid required for internal users, in all other users it will be ignored
         * @summary returns list of documents avaialble to user.
         * @param {number} issuerid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuerDocumentIssuerIssueridGet(issuerid: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IssuerDocumentModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuerDocumentIssuerIssueridGet(issuerid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns List Of pending Documents available to user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuerDocumentPendingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IssuerDocumentModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuerDocumentPendingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary creates a new document
         * @param {string} [documentId] 
         * @param {string} [fileName] 
         * @param {boolean} [isConfidential] 
         * @param {string} [externalUrl] 
         * @param {string} [comment] 
         * @param {string} [firstCreatedBy] 
         * @param {string} [firstCreatedDate] 
         * @param {string} [lastUpdatedBy] 
         * @param {string} [lastUpdatedDate] 
         * @param {number} [issuerId] 
         * @param {string} [issuerName] 
         * @param {StatusAprovalSimplifiedEnum} [status] 
         * @param {DocumentTypeEnum} [documentTypeCode] 
         * @param {File} [formFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuerDocumentPost(documentId?: string, fileName?: string, isConfidential?: boolean, externalUrl?: string, comment?: string, firstCreatedBy?: string, firstCreatedDate?: string, lastUpdatedBy?: string, lastUpdatedDate?: string, issuerId?: number, issuerName?: string, status?: StatusAprovalSimplifiedEnum, documentTypeCode?: DocumentTypeEnum, formFile?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssuerDocumentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuerDocumentPost(documentId, fileName, isConfidential, externalUrl, comment, firstCreatedBy, firstCreatedDate, lastUpdatedBy, lastUpdatedDate, issuerId, issuerName, status, documentTypeCode, formFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates Specific IssuerDocument
         * @param {IssuerDocumentModel} [issuerDocumentModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuerDocumentUpdatePut(issuerDocumentModel?: IssuerDocumentModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssuerDocumentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuerDocumentUpdatePut(issuerDocumentModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IssuerDocumentApi - factory interface
 * @export
 */
export const IssuerDocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IssuerDocumentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentDocumentIdDelete(documentId: string, options?: any): AxiosPromise<IssuerDocumentModel> {
            return localVarFp.apiIssuerDocumentDocumentIdDelete(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates Specific IssuerDocumdent STATUS
         * @param {string} documentId 
         * @param {StatusAprovalSimplifiedEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentDocumentIdPatch(documentId: string, status?: StatusAprovalSimplifiedEnum, options?: any): AxiosPromise<IssuerDocumentModel> {
            return localVarFp.apiIssuerDocumentDocumentIdPatch(documentId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets user agreement for specific organization
         * @param {string} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentDownloadDocumentIdGet(documentId: string, options?: any): AxiosPromise<FileStream> {
            return localVarFp.apiIssuerDocumentDownloadDocumentIdGet(documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * issuerid required for internal users, in all other users it will be ignored
         * @summary returns list of documents avaialble to user.
         * @param {number} issuerid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentIssuerIssueridGet(issuerid: number, options?: any): AxiosPromise<Array<IssuerDocumentModel>> {
            return localVarFp.apiIssuerDocumentIssuerIssueridGet(issuerid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns List Of pending Documents available to user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentPendingGet(options?: any): AxiosPromise<Array<IssuerDocumentModel>> {
            return localVarFp.apiIssuerDocumentPendingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary creates a new document
         * @param {string} [documentId] 
         * @param {string} [fileName] 
         * @param {boolean} [isConfidential] 
         * @param {string} [externalUrl] 
         * @param {string} [comment] 
         * @param {string} [firstCreatedBy] 
         * @param {string} [firstCreatedDate] 
         * @param {string} [lastUpdatedBy] 
         * @param {string} [lastUpdatedDate] 
         * @param {number} [issuerId] 
         * @param {string} [issuerName] 
         * @param {StatusAprovalSimplifiedEnum} [status] 
         * @param {DocumentTypeEnum} [documentTypeCode] 
         * @param {File} [formFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentPost(documentId?: string, fileName?: string, isConfidential?: boolean, externalUrl?: string, comment?: string, firstCreatedBy?: string, firstCreatedDate?: string, lastUpdatedBy?: string, lastUpdatedDate?: string, issuerId?: number, issuerName?: string, status?: StatusAprovalSimplifiedEnum, documentTypeCode?: DocumentTypeEnum, formFile?: File, options?: any): AxiosPromise<IssuerDocumentModel> {
            return localVarFp.apiIssuerDocumentPost(documentId, fileName, isConfidential, externalUrl, comment, firstCreatedBy, firstCreatedDate, lastUpdatedBy, lastUpdatedDate, issuerId, issuerName, status, documentTypeCode, formFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates Specific IssuerDocument
         * @param {IssuerDocumentModel} [issuerDocumentModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuerDocumentUpdatePut(issuerDocumentModel?: IssuerDocumentModel, options?: any): AxiosPromise<IssuerDocumentModel> {
            return localVarFp.apiIssuerDocumentUpdatePut(issuerDocumentModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IssuerDocumentApi - interface
 * @export
 * @interface IssuerDocumentApi
 */
export interface IssuerDocumentApiInterface {
    /**
     * 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApiInterface
     */
    apiIssuerDocumentDocumentIdDelete(documentId: string, options?: AxiosRequestConfig): AxiosPromise<IssuerDocumentModel>;

    /**
     * 
     * @summary Updates Specific IssuerDocumdent STATUS
     * @param {string} documentId 
     * @param {StatusAprovalSimplifiedEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApiInterface
     */
    apiIssuerDocumentDocumentIdPatch(documentId: string, status?: StatusAprovalSimplifiedEnum, options?: AxiosRequestConfig): AxiosPromise<IssuerDocumentModel>;

    /**
     * 
     * @summary Gets user agreement for specific organization
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApiInterface
     */
    apiIssuerDocumentDownloadDocumentIdGet(documentId: string, options?: AxiosRequestConfig): AxiosPromise<FileStream>;

    /**
     * issuerid required for internal users, in all other users it will be ignored
     * @summary returns list of documents avaialble to user.
     * @param {number} issuerid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApiInterface
     */
    apiIssuerDocumentIssuerIssueridGet(issuerid: number, options?: AxiosRequestConfig): AxiosPromise<Array<IssuerDocumentModel>>;

    /**
     * 
     * @summary Returns List Of pending Documents available to user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApiInterface
     */
    apiIssuerDocumentPendingGet(options?: AxiosRequestConfig): AxiosPromise<Array<IssuerDocumentModel>>;

    /**
     * 
     * @summary creates a new document
     * @param {string} [documentId] 
     * @param {string} [fileName] 
     * @param {boolean} [isConfidential] 
     * @param {string} [externalUrl] 
     * @param {string} [comment] 
     * @param {string} [firstCreatedBy] 
     * @param {string} [firstCreatedDate] 
     * @param {string} [lastUpdatedBy] 
     * @param {string} [lastUpdatedDate] 
     * @param {number} [issuerId] 
     * @param {string} [issuerName] 
     * @param {StatusAprovalSimplifiedEnum} [status] 
     * @param {DocumentTypeEnum} [documentTypeCode] 
     * @param {File} [formFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApiInterface
     */
    apiIssuerDocumentPost(documentId?: string, fileName?: string, isConfidential?: boolean, externalUrl?: string, comment?: string, firstCreatedBy?: string, firstCreatedDate?: string, lastUpdatedBy?: string, lastUpdatedDate?: string, issuerId?: number, issuerName?: string, status?: StatusAprovalSimplifiedEnum, documentTypeCode?: DocumentTypeEnum, formFile?: File, options?: AxiosRequestConfig): AxiosPromise<IssuerDocumentModel>;

    /**
     * 
     * @summary Updates Specific IssuerDocument
     * @param {IssuerDocumentModel} [issuerDocumentModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApiInterface
     */
    apiIssuerDocumentUpdatePut(issuerDocumentModel?: IssuerDocumentModel, options?: AxiosRequestConfig): AxiosPromise<IssuerDocumentModel>;

}

/**
 * IssuerDocumentApi - object-oriented interface
 * @export
 * @class IssuerDocumentApi
 * @extends {BaseAPI}
 */
export class IssuerDocumentApi extends BaseAPI implements IssuerDocumentApiInterface {
    /**
     * 
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApi
     */
    public apiIssuerDocumentDocumentIdDelete(documentId: string, options?: AxiosRequestConfig) {
        return IssuerDocumentApiFp(this.configuration).apiIssuerDocumentDocumentIdDelete(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates Specific IssuerDocumdent STATUS
     * @param {string} documentId 
     * @param {StatusAprovalSimplifiedEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApi
     */
    public apiIssuerDocumentDocumentIdPatch(documentId: string, status?: StatusAprovalSimplifiedEnum, options?: AxiosRequestConfig) {
        return IssuerDocumentApiFp(this.configuration).apiIssuerDocumentDocumentIdPatch(documentId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets user agreement for specific organization
     * @param {string} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApi
     */
    public apiIssuerDocumentDownloadDocumentIdGet(documentId: string, options?: AxiosRequestConfig) {
        return IssuerDocumentApiFp(this.configuration).apiIssuerDocumentDownloadDocumentIdGet(documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * issuerid required for internal users, in all other users it will be ignored
     * @summary returns list of documents avaialble to user.
     * @param {number} issuerid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApi
     */
    public apiIssuerDocumentIssuerIssueridGet(issuerid: number, options?: AxiosRequestConfig) {
        return IssuerDocumentApiFp(this.configuration).apiIssuerDocumentIssuerIssueridGet(issuerid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns List Of pending Documents available to user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApi
     */
    public apiIssuerDocumentPendingGet(options?: AxiosRequestConfig) {
        return IssuerDocumentApiFp(this.configuration).apiIssuerDocumentPendingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary creates a new document
     * @param {string} [documentId] 
     * @param {string} [fileName] 
     * @param {boolean} [isConfidential] 
     * @param {string} [externalUrl] 
     * @param {string} [comment] 
     * @param {string} [firstCreatedBy] 
     * @param {string} [firstCreatedDate] 
     * @param {string} [lastUpdatedBy] 
     * @param {string} [lastUpdatedDate] 
     * @param {number} [issuerId] 
     * @param {string} [issuerName] 
     * @param {StatusAprovalSimplifiedEnum} [status] 
     * @param {DocumentTypeEnum} [documentTypeCode] 
     * @param {File} [formFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApi
     */
    public apiIssuerDocumentPost(documentId?: string, fileName?: string, isConfidential?: boolean, externalUrl?: string, comment?: string, firstCreatedBy?: string, firstCreatedDate?: string, lastUpdatedBy?: string, lastUpdatedDate?: string, issuerId?: number, issuerName?: string, status?: StatusAprovalSimplifiedEnum, documentTypeCode?: DocumentTypeEnum, formFile?: File, options?: AxiosRequestConfig) {
        return IssuerDocumentApiFp(this.configuration).apiIssuerDocumentPost(documentId, fileName, isConfidential, externalUrl, comment, firstCreatedBy, firstCreatedDate, lastUpdatedBy, lastUpdatedDate, issuerId, issuerName, status, documentTypeCode, formFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates Specific IssuerDocument
     * @param {IssuerDocumentModel} [issuerDocumentModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuerDocumentApi
     */
    public apiIssuerDocumentUpdatePut(issuerDocumentModel?: IssuerDocumentModel, options?: AxiosRequestConfig) {
        return IssuerDocumentApiFp(this.configuration).apiIssuerDocumentUpdatePut(issuerDocumentModel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IssuersApi - axios parameter creator
 * @export
 */
export const IssuersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves all Active issuers, This method should be used for None Supervisor users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersActiveGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Issuers/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all Active issuers, This method should be used for Supervisor users only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersAllGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Issuers/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes FUTURE  billing contact, by BillingContact PK. Success = 204
         * @param {string} billingContactPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersBillingcontactBillingContactPkDelete: async (billingContactPk: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billingContactPk' is not null or undefined
            assertParamExists('apiIssuersBillingcontactBillingContactPkDelete', 'billingContactPk', billingContactPk)
            const localVarPath = `/api/Issuers/billingcontact/{billingContactPk}`
                .replace(`{${"billingContactPk"}}`, encodeURIComponent(String(billingContactPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets All Billing Contacts for selected issuer, by issuer pk
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkAllbillingcontactsGet: async (issuerPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkAllbillingcontactsGet', 'issuerPk', issuerPk)
            const localVarPath = `/api/Issuers/{issuerPk}/allbillingcontacts`
                .replace(`{${"issuerPk"}}`, encodeURIComponent(String(issuerPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates New Billing Contact
         * @param {number} issuerPk 
         * @param {number} contactPk 
         * @param {string} [effectiveDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkBillingcontactContactPkPost: async (issuerPk: number, contactPk: number, effectiveDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkBillingcontactContactPkPost', 'issuerPk', issuerPk)
            // verify required parameter 'contactPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkBillingcontactContactPkPost', 'contactPk', contactPk)
            const localVarPath = `/api/Issuers/{issuerPk}/billingcontact/{contactPk}`
                .replace(`{${"issuerPk"}}`, encodeURIComponent(String(issuerPk)))
                .replace(`{${"contactPk"}}`, encodeURIComponent(String(contactPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (effectiveDate !== undefined) {
                localVarQueryParameter['effectiveDate'] = (effectiveDate as any instanceof Date) ?
                    (effectiveDate as any).toISOString() :
                    effectiveDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets Current Billing Contact for selected issuer, by issuer pk.
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkCurrentbillingcontactGet: async (issuerPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkCurrentbillingcontactGet', 'issuerPk', issuerPk)
            const localVarPath = `/api/Issuers/{issuerPk}/currentbillingcontact`
                .replace(`{${"issuerPk"}}`, encodeURIComponent(String(issuerPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets Scheduled Billing Contacts for selected issuer, by issuer pk
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkFuturebillingcontactsGet: async (issuerPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkFuturebillingcontactsGet', 'issuerPk', issuerPk)
            const localVarPath = `/api/Issuers/{issuerPk}/futurebillingcontacts`
                .replace(`{${"issuerPk"}}`, encodeURIComponent(String(issuerPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves Issuer by Primary key
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkGet: async (issuerPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkGet', 'issuerPk', issuerPk)
            const localVarPath = `/api/Issuers/{issuerPk}`
                .replace(`{${"issuerPk"}}`, encodeURIComponent(String(issuerPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates Listing Conatct
         * @param {number} issuerPk 
         * @param {number} contactPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkListingcontactContactPkPost: async (issuerPk: number, contactPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkListingcontactContactPkPost', 'issuerPk', issuerPk)
            // verify required parameter 'contactPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkListingcontactContactPkPost', 'contactPk', contactPk)
            const localVarPath = `/api/Issuers/{issuerPk}/listingcontact/{contactPk}`
                .replace(`{${"issuerPk"}}`, encodeURIComponent(String(issuerPk)))
                .replace(`{${"contactPk"}}`, encodeURIComponent(String(contactPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets List of Listing contacts for specific Issuer by Issuer PK
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkListingcontactsGet: async (issuerPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkListingcontactsGet', 'issuerPk', issuerPk)
            const localVarPath = `/api/Issuers/{issuerPk}/listingcontacts`
                .replace(`{${"issuerPk"}}`, encodeURIComponent(String(issuerPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves all Organization Relations for the Issuer by issuer Primary key.
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkRelationsGet: async (issuerPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkRelationsGet', 'issuerPk', issuerPk)
            const localVarPath = `/api/Issuers/{issuerPk}/relations`
                .replace(`{${"issuerPk"}}`, encodeURIComponent(String(issuerPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes Organization Issuer relation. Success = 404
         * @param {number} issuerPk 
         * @param {string} organizationIssuerRelationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdDelete: async (issuerPk: number, organizationIssuerRelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdDelete', 'issuerPk', issuerPk)
            // verify required parameter 'organizationIssuerRelationId' is not null or undefined
            assertParamExists('apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdDelete', 'organizationIssuerRelationId', organizationIssuerRelationId)
            const localVarPath = `/api/Issuers/{issuerPk}/relations/{organizationIssuerRelationId}`
                .replace(`{${"issuerPk"}}`, encodeURIComponent(String(issuerPk)))
                .replace(`{${"organizationIssuerRelationId"}}`, encodeURIComponent(String(organizationIssuerRelationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves Single Organization Relation for the Issuer by issuer Primary key and relation primary key
         * @param {number} issuerPk 
         * @param {string} organizationIssuerRelationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdGet: async (issuerPk: number, organizationIssuerRelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdGet', 'issuerPk', issuerPk)
            // verify required parameter 'organizationIssuerRelationId' is not null or undefined
            assertParamExists('apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdGet', 'organizationIssuerRelationId', organizationIssuerRelationId)
            const localVarPath = `/api/Issuers/{issuerPk}/relations/{organizationIssuerRelationId}`
                .replace(`{${"issuerPk"}}`, encodeURIComponent(String(issuerPk)))
                .replace(`{${"organizationIssuerRelationId"}}`, encodeURIComponent(String(organizationIssuerRelationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates STATUS of OrganizationIssuer relation. Single field.
         * @param {number} issuerPk 
         * @param {string} organizationIssuerRelationId 
         * @param {StatusBasicEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPatch: async (issuerPk: number, organizationIssuerRelationId: string, status?: StatusBasicEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPatch', 'issuerPk', issuerPk)
            // verify required parameter 'organizationIssuerRelationId' is not null or undefined
            assertParamExists('apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPatch', 'organizationIssuerRelationId', organizationIssuerRelationId)
            const localVarPath = `/api/Issuers/{issuerPk}/relations/{organizationIssuerRelationId}`
                .replace(`{${"issuerPk"}}`, encodeURIComponent(String(issuerPk)))
                .replace(`{${"organizationIssuerRelationId"}}`, encodeURIComponent(String(organizationIssuerRelationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates OrganizationIssuer relation
         * @param {number} issuerPk 
         * @param {string} organizationIssuerRelationId 
         * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPut: async (issuerPk: number, organizationIssuerRelationId: string, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPut', 'issuerPk', issuerPk)
            // verify required parameter 'organizationIssuerRelationId' is not null or undefined
            assertParamExists('apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPut', 'organizationIssuerRelationId', organizationIssuerRelationId)
            const localVarPath = `/api/Issuers/{issuerPk}/relations/{organizationIssuerRelationId}`
                .replace(`{${"issuerPk"}}`, encodeURIComponent(String(issuerPk)))
                .replace(`{${"organizationIssuerRelationId"}}`, encodeURIComponent(String(organizationIssuerRelationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationIssuerRelationModelPartial, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates of OrganizationIssuer relation
         * @param {number} issuerPk 
         * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkRelationsPost: async (issuerPk: number, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerPk' is not null or undefined
            assertParamExists('apiIssuersIssuerPkRelationsPost', 'issuerPk', issuerPk)
            const localVarPath = `/api/Issuers/{issuerPk}/relations`
                .replace(`{${"issuerPk"}}`, encodeURIComponent(String(issuerPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationIssuerRelationModelPartial, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes Listing Contact, by ListingContact PK. Success = 204
         * @param {string} listingcontactPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersListingcontactListingcontactPkDelete: async (listingcontactPk: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingcontactPk' is not null or undefined
            assertParamExists('apiIssuersListingcontactListingcontactPkDelete', 'listingcontactPk', listingcontactPk)
            const localVarPath = `/api/Issuers/listingcontact/{listingcontactPk}`
                .replace(`{${"listingcontactPk"}}`, encodeURIComponent(String(listingcontactPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search fields Issuername,  IssuerCode(prefix, exact), IssuerCusip (exact). Paging is optional. Order by  IssuerName hardcodded. Price field in parameters ignored
         * @summary Search Issuers
         * @param {OrganizationIssuerSearchParams} [organizationIssuerSearchParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersSearchPost: async (organizationIssuerSearchParams?: OrganizationIssuerSearchParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Issuers/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationIssuerSearchParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IssuersApi - functional programming interface
 * @export
 */
export const IssuersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IssuersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves all Active issuers, This method should be used for None Supervisor users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersActiveGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IssuerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersActiveGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves all Active issuers, This method should be used for Supervisor users only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersAllGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IssuerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersAllGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes FUTURE  billing contact, by BillingContact PK. Success = 204
         * @param {string} billingContactPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersBillingcontactBillingContactPkDelete(billingContactPk: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingContactModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersBillingcontactBillingContactPkDelete(billingContactPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets All Billing Contacts for selected issuer, by issuer pk
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersIssuerPkAllbillingcontactsGet(issuerPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BillingContactModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersIssuerPkAllbillingcontactsGet(issuerPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates New Billing Contact
         * @param {number} issuerPk 
         * @param {number} contactPk 
         * @param {string} [effectiveDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersIssuerPkBillingcontactContactPkPost(issuerPk: number, contactPk: number, effectiveDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingContactModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersIssuerPkBillingcontactContactPkPost(issuerPk, contactPk, effectiveDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets Current Billing Contact for selected issuer, by issuer pk.
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersIssuerPkCurrentbillingcontactGet(issuerPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillingContactModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersIssuerPkCurrentbillingcontactGet(issuerPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets Scheduled Billing Contacts for selected issuer, by issuer pk
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersIssuerPkFuturebillingcontactsGet(issuerPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BillingContactModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersIssuerPkFuturebillingcontactsGet(issuerPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves Issuer by Primary key
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersIssuerPkGet(issuerPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssuerModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersIssuerPkGet(issuerPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates Listing Conatct
         * @param {number} issuerPk 
         * @param {number} contactPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersIssuerPkListingcontactContactPkPost(issuerPk: number, contactPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingContactModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersIssuerPkListingcontactContactPkPost(issuerPk, contactPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets List of Listing contacts for specific Issuer by Issuer PK
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersIssuerPkListingcontactsGet(issuerPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ListingContactModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersIssuerPkListingcontactsGet(issuerPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves all Organization Relations for the Issuer by issuer Primary key.
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersIssuerPkRelationsGet(issuerPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationIssuerRelationModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersIssuerPkRelationsGet(issuerPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes Organization Issuer relation. Success = 404
         * @param {number} issuerPk 
         * @param {string} organizationIssuerRelationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdDelete(issuerPk: number, organizationIssuerRelationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationIssuerRelationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdDelete(issuerPk, organizationIssuerRelationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves Single Organization Relation for the Issuer by issuer Primary key and relation primary key
         * @param {number} issuerPk 
         * @param {string} organizationIssuerRelationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdGet(issuerPk: number, organizationIssuerRelationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationIssuerRelationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdGet(issuerPk, organizationIssuerRelationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates STATUS of OrganizationIssuer relation. Single field.
         * @param {number} issuerPk 
         * @param {string} organizationIssuerRelationId 
         * @param {StatusBasicEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPatch(issuerPk: number, organizationIssuerRelationId: string, status?: StatusBasicEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationIssuerRelationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPatch(issuerPk, organizationIssuerRelationId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates OrganizationIssuer relation
         * @param {number} issuerPk 
         * @param {string} organizationIssuerRelationId 
         * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPut(issuerPk: number, organizationIssuerRelationId: string, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationIssuerRelationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPut(issuerPk, organizationIssuerRelationId, organizationIssuerRelationModelPartial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates of OrganizationIssuer relation
         * @param {number} issuerPk 
         * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersIssuerPkRelationsPost(issuerPk: number, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationIssuerRelationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersIssuerPkRelationsPost(issuerPk, organizationIssuerRelationModelPartial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes Listing Contact, by ListingContact PK. Success = 204
         * @param {string} listingcontactPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersListingcontactListingcontactPkDelete(listingcontactPk: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListingContactModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersListingcontactListingcontactPkDelete(listingcontactPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search fields Issuername,  IssuerCode(prefix, exact), IssuerCusip (exact). Paging is optional. Order by  IssuerName hardcodded. Price field in parameters ignored
         * @summary Search Issuers
         * @param {OrganizationIssuerSearchParams} [organizationIssuerSearchParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIssuersSearchPost(organizationIssuerSearchParams?: OrganizationIssuerSearchParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IssuerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIssuersSearchPost(organizationIssuerSearchParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IssuersApi - factory interface
 * @export
 */
export const IssuersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IssuersApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves all Active issuers, This method should be used for None Supervisor users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersActiveGet(options?: any): AxiosPromise<Array<IssuerModel>> {
            return localVarFp.apiIssuersActiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all Active issuers, This method should be used for Supervisor users only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersAllGet(options?: any): AxiosPromise<Array<IssuerModel>> {
            return localVarFp.apiIssuersAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes FUTURE  billing contact, by BillingContact PK. Success = 204
         * @param {string} billingContactPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersBillingcontactBillingContactPkDelete(billingContactPk: string, options?: any): AxiosPromise<ListingContactModel> {
            return localVarFp.apiIssuersBillingcontactBillingContactPkDelete(billingContactPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets All Billing Contacts for selected issuer, by issuer pk
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkAllbillingcontactsGet(issuerPk: number, options?: any): AxiosPromise<Array<BillingContactModel>> {
            return localVarFp.apiIssuersIssuerPkAllbillingcontactsGet(issuerPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates New Billing Contact
         * @param {number} issuerPk 
         * @param {number} contactPk 
         * @param {string} [effectiveDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkBillingcontactContactPkPost(issuerPk: number, contactPk: number, effectiveDate?: string, options?: any): AxiosPromise<BillingContactModel> {
            return localVarFp.apiIssuersIssuerPkBillingcontactContactPkPost(issuerPk, contactPk, effectiveDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets Current Billing Contact for selected issuer, by issuer pk.
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkCurrentbillingcontactGet(issuerPk: number, options?: any): AxiosPromise<BillingContactModel> {
            return localVarFp.apiIssuersIssuerPkCurrentbillingcontactGet(issuerPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets Scheduled Billing Contacts for selected issuer, by issuer pk
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkFuturebillingcontactsGet(issuerPk: number, options?: any): AxiosPromise<Array<BillingContactModel>> {
            return localVarFp.apiIssuersIssuerPkFuturebillingcontactsGet(issuerPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves Issuer by Primary key
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkGet(issuerPk: number, options?: any): AxiosPromise<IssuerModel> {
            return localVarFp.apiIssuersIssuerPkGet(issuerPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates Listing Conatct
         * @param {number} issuerPk 
         * @param {number} contactPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkListingcontactContactPkPost(issuerPk: number, contactPk: number, options?: any): AxiosPromise<ListingContactModel> {
            return localVarFp.apiIssuersIssuerPkListingcontactContactPkPost(issuerPk, contactPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets List of Listing contacts for specific Issuer by Issuer PK
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkListingcontactsGet(issuerPk: number, options?: any): AxiosPromise<Array<ListingContactModel>> {
            return localVarFp.apiIssuersIssuerPkListingcontactsGet(issuerPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves all Organization Relations for the Issuer by issuer Primary key.
         * @param {number} issuerPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkRelationsGet(issuerPk: number, options?: any): AxiosPromise<Array<OrganizationIssuerRelationModel>> {
            return localVarFp.apiIssuersIssuerPkRelationsGet(issuerPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes Organization Issuer relation. Success = 404
         * @param {number} issuerPk 
         * @param {string} organizationIssuerRelationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdDelete(issuerPk: number, organizationIssuerRelationId: string, options?: any): AxiosPromise<OrganizationIssuerRelationModel> {
            return localVarFp.apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdDelete(issuerPk, organizationIssuerRelationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves Single Organization Relation for the Issuer by issuer Primary key and relation primary key
         * @param {number} issuerPk 
         * @param {string} organizationIssuerRelationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdGet(issuerPk: number, organizationIssuerRelationId: string, options?: any): AxiosPromise<OrganizationIssuerRelationModel> {
            return localVarFp.apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdGet(issuerPk, organizationIssuerRelationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates STATUS of OrganizationIssuer relation. Single field.
         * @param {number} issuerPk 
         * @param {string} organizationIssuerRelationId 
         * @param {StatusBasicEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPatch(issuerPk: number, organizationIssuerRelationId: string, status?: StatusBasicEnum, options?: any): AxiosPromise<OrganizationIssuerRelationModel> {
            return localVarFp.apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPatch(issuerPk, organizationIssuerRelationId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates OrganizationIssuer relation
         * @param {number} issuerPk 
         * @param {string} organizationIssuerRelationId 
         * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPut(issuerPk: number, organizationIssuerRelationId: string, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: any): AxiosPromise<OrganizationIssuerRelationModel> {
            return localVarFp.apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPut(issuerPk, organizationIssuerRelationId, organizationIssuerRelationModelPartial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates of OrganizationIssuer relation
         * @param {number} issuerPk 
         * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersIssuerPkRelationsPost(issuerPk: number, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: any): AxiosPromise<OrganizationIssuerRelationModel> {
            return localVarFp.apiIssuersIssuerPkRelationsPost(issuerPk, organizationIssuerRelationModelPartial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes Listing Contact, by ListingContact PK. Success = 204
         * @param {string} listingcontactPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersListingcontactListingcontactPkDelete(listingcontactPk: string, options?: any): AxiosPromise<ListingContactModel> {
            return localVarFp.apiIssuersListingcontactListingcontactPkDelete(listingcontactPk, options).then((request) => request(axios, basePath));
        },
        /**
         * Search fields Issuername,  IssuerCode(prefix, exact), IssuerCusip (exact). Paging is optional. Order by  IssuerName hardcodded. Price field in parameters ignored
         * @summary Search Issuers
         * @param {OrganizationIssuerSearchParams} [organizationIssuerSearchParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIssuersSearchPost(organizationIssuerSearchParams?: OrganizationIssuerSearchParams, options?: any): AxiosPromise<Array<IssuerModel>> {
            return localVarFp.apiIssuersSearchPost(organizationIssuerSearchParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IssuersApi - interface
 * @export
 * @interface IssuersApi
 */
export interface IssuersApiInterface {
    /**
     * 
     * @summary Retrieves all Active issuers, This method should be used for None Supervisor users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersActiveGet(options?: AxiosRequestConfig): AxiosPromise<Array<IssuerModel>>;

    /**
     * 
     * @summary Retrieves all Active issuers, This method should be used for Supervisor users only
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersAllGet(options?: AxiosRequestConfig): AxiosPromise<Array<IssuerModel>>;

    /**
     * 
     * @summary Deletes FUTURE  billing contact, by BillingContact PK. Success = 204
     * @param {string} billingContactPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersBillingcontactBillingContactPkDelete(billingContactPk: string, options?: AxiosRequestConfig): AxiosPromise<ListingContactModel>;

    /**
     * 
     * @summary Gets All Billing Contacts for selected issuer, by issuer pk
     * @param {number} issuerPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersIssuerPkAllbillingcontactsGet(issuerPk: number, options?: AxiosRequestConfig): AxiosPromise<Array<BillingContactModel>>;

    /**
     * 
     * @summary Creates New Billing Contact
     * @param {number} issuerPk 
     * @param {number} contactPk 
     * @param {string} [effectiveDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersIssuerPkBillingcontactContactPkPost(issuerPk: number, contactPk: number, effectiveDate?: string, options?: AxiosRequestConfig): AxiosPromise<BillingContactModel>;

    /**
     * 
     * @summary Gets Current Billing Contact for selected issuer, by issuer pk.
     * @param {number} issuerPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersIssuerPkCurrentbillingcontactGet(issuerPk: number, options?: AxiosRequestConfig): AxiosPromise<BillingContactModel>;

    /**
     * 
     * @summary Gets Scheduled Billing Contacts for selected issuer, by issuer pk
     * @param {number} issuerPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersIssuerPkFuturebillingcontactsGet(issuerPk: number, options?: AxiosRequestConfig): AxiosPromise<Array<BillingContactModel>>;

    /**
     * 
     * @summary Retrieves Issuer by Primary key
     * @param {number} issuerPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersIssuerPkGet(issuerPk: number, options?: AxiosRequestConfig): AxiosPromise<IssuerModel>;

    /**
     * 
     * @summary Creates Listing Conatct
     * @param {number} issuerPk 
     * @param {number} contactPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersIssuerPkListingcontactContactPkPost(issuerPk: number, contactPk: number, options?: AxiosRequestConfig): AxiosPromise<ListingContactModel>;

    /**
     * 
     * @summary Gets List of Listing contacts for specific Issuer by Issuer PK
     * @param {number} issuerPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersIssuerPkListingcontactsGet(issuerPk: number, options?: AxiosRequestConfig): AxiosPromise<Array<ListingContactModel>>;

    /**
     * 
     * @summary Retrieves all Organization Relations for the Issuer by issuer Primary key.
     * @param {number} issuerPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersIssuerPkRelationsGet(issuerPk: number, options?: AxiosRequestConfig): AxiosPromise<Array<OrganizationIssuerRelationModel>>;

    /**
     * 
     * @summary Deletes Organization Issuer relation. Success = 404
     * @param {number} issuerPk 
     * @param {string} organizationIssuerRelationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdDelete(issuerPk: number, organizationIssuerRelationId: string, options?: AxiosRequestConfig): AxiosPromise<OrganizationIssuerRelationModel>;

    /**
     * 
     * @summary Retrieves Single Organization Relation for the Issuer by issuer Primary key and relation primary key
     * @param {number} issuerPk 
     * @param {string} organizationIssuerRelationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdGet(issuerPk: number, organizationIssuerRelationId: string, options?: AxiosRequestConfig): AxiosPromise<OrganizationIssuerRelationModel>;

    /**
     * 
     * @summary Updates STATUS of OrganizationIssuer relation. Single field.
     * @param {number} issuerPk 
     * @param {string} organizationIssuerRelationId 
     * @param {StatusBasicEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPatch(issuerPk: number, organizationIssuerRelationId: string, status?: StatusBasicEnum, options?: AxiosRequestConfig): AxiosPromise<OrganizationIssuerRelationModel>;

    /**
     * 
     * @summary Updates OrganizationIssuer relation
     * @param {number} issuerPk 
     * @param {string} organizationIssuerRelationId 
     * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPut(issuerPk: number, organizationIssuerRelationId: string, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: AxiosRequestConfig): AxiosPromise<OrganizationIssuerRelationModel>;

    /**
     * 
     * @summary Creates of OrganizationIssuer relation
     * @param {number} issuerPk 
     * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersIssuerPkRelationsPost(issuerPk: number, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: AxiosRequestConfig): AxiosPromise<OrganizationIssuerRelationModel>;

    /**
     * 
     * @summary Deletes Listing Contact, by ListingContact PK. Success = 204
     * @param {string} listingcontactPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersListingcontactListingcontactPkDelete(listingcontactPk: string, options?: AxiosRequestConfig): AxiosPromise<ListingContactModel>;

    /**
     * Search fields Issuername,  IssuerCode(prefix, exact), IssuerCusip (exact). Paging is optional. Order by  IssuerName hardcodded. Price field in parameters ignored
     * @summary Search Issuers
     * @param {OrganizationIssuerSearchParams} [organizationIssuerSearchParams] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApiInterface
     */
    apiIssuersSearchPost(organizationIssuerSearchParams?: OrganizationIssuerSearchParams, options?: AxiosRequestConfig): AxiosPromise<Array<IssuerModel>>;

}

/**
 * IssuersApi - object-oriented interface
 * @export
 * @class IssuersApi
 * @extends {BaseAPI}
 */
export class IssuersApi extends BaseAPI implements IssuersApiInterface {
    /**
     * 
     * @summary Retrieves all Active issuers, This method should be used for None Supervisor users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersActiveGet(options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersActiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all Active issuers, This method should be used for Supervisor users only
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersAllGet(options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersAllGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes FUTURE  billing contact, by BillingContact PK. Success = 204
     * @param {string} billingContactPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersBillingcontactBillingContactPkDelete(billingContactPk: string, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersBillingcontactBillingContactPkDelete(billingContactPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets All Billing Contacts for selected issuer, by issuer pk
     * @param {number} issuerPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersIssuerPkAllbillingcontactsGet(issuerPk: number, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersIssuerPkAllbillingcontactsGet(issuerPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates New Billing Contact
     * @param {number} issuerPk 
     * @param {number} contactPk 
     * @param {string} [effectiveDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersIssuerPkBillingcontactContactPkPost(issuerPk: number, contactPk: number, effectiveDate?: string, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersIssuerPkBillingcontactContactPkPost(issuerPk, contactPk, effectiveDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets Current Billing Contact for selected issuer, by issuer pk.
     * @param {number} issuerPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersIssuerPkCurrentbillingcontactGet(issuerPk: number, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersIssuerPkCurrentbillingcontactGet(issuerPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets Scheduled Billing Contacts for selected issuer, by issuer pk
     * @param {number} issuerPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersIssuerPkFuturebillingcontactsGet(issuerPk: number, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersIssuerPkFuturebillingcontactsGet(issuerPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves Issuer by Primary key
     * @param {number} issuerPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersIssuerPkGet(issuerPk: number, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersIssuerPkGet(issuerPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates Listing Conatct
     * @param {number} issuerPk 
     * @param {number} contactPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersIssuerPkListingcontactContactPkPost(issuerPk: number, contactPk: number, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersIssuerPkListingcontactContactPkPost(issuerPk, contactPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets List of Listing contacts for specific Issuer by Issuer PK
     * @param {number} issuerPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersIssuerPkListingcontactsGet(issuerPk: number, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersIssuerPkListingcontactsGet(issuerPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves all Organization Relations for the Issuer by issuer Primary key.
     * @param {number} issuerPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersIssuerPkRelationsGet(issuerPk: number, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersIssuerPkRelationsGet(issuerPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes Organization Issuer relation. Success = 404
     * @param {number} issuerPk 
     * @param {string} organizationIssuerRelationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdDelete(issuerPk: number, organizationIssuerRelationId: string, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdDelete(issuerPk, organizationIssuerRelationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves Single Organization Relation for the Issuer by issuer Primary key and relation primary key
     * @param {number} issuerPk 
     * @param {string} organizationIssuerRelationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdGet(issuerPk: number, organizationIssuerRelationId: string, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdGet(issuerPk, organizationIssuerRelationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates STATUS of OrganizationIssuer relation. Single field.
     * @param {number} issuerPk 
     * @param {string} organizationIssuerRelationId 
     * @param {StatusBasicEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPatch(issuerPk: number, organizationIssuerRelationId: string, status?: StatusBasicEnum, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPatch(issuerPk, organizationIssuerRelationId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates OrganizationIssuer relation
     * @param {number} issuerPk 
     * @param {string} organizationIssuerRelationId 
     * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPut(issuerPk: number, organizationIssuerRelationId: string, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersIssuerPkRelationsOrganizationIssuerRelationIdPut(issuerPk, organizationIssuerRelationId, organizationIssuerRelationModelPartial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates of OrganizationIssuer relation
     * @param {number} issuerPk 
     * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersIssuerPkRelationsPost(issuerPk: number, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersIssuerPkRelationsPost(issuerPk, organizationIssuerRelationModelPartial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes Listing Contact, by ListingContact PK. Success = 204
     * @param {string} listingcontactPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersListingcontactListingcontactPkDelete(listingcontactPk: string, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersListingcontactListingcontactPkDelete(listingcontactPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search fields Issuername,  IssuerCode(prefix, exact), IssuerCusip (exact). Paging is optional. Order by  IssuerName hardcodded. Price field in parameters ignored
     * @summary Search Issuers
     * @param {OrganizationIssuerSearchParams} [organizationIssuerSearchParams] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IssuersApi
     */
    public apiIssuersSearchPost(organizationIssuerSearchParams?: OrganizationIssuerSearchParams, options?: AxiosRequestConfig) {
        return IssuersApiFp(this.configuration).apiIssuersSearchPost(organizationIssuerSearchParams, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationStagesApi - axios parameter creator
 * @export
 */
export const OrganizationStagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets List of Organization Stage, for Organization Approval
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OrganizationStages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes Organization Stage
         * @param {string} organizationStageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStageIdDelete: async (organizationStageId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationStageId' is not null or undefined
            assertParamExists('apiOrganizationStagesOrganizationStageIdDelete', 'organizationStageId', organizationStageId)
            const localVarPath = `/api/OrganizationStages/{organizationStageId}`
                .replace(`{${"organizationStageId"}}`, encodeURIComponent(String(organizationStageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets Organization Stage by Organization Stage Pk
         * @param {string} organizationStageModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStageModelIdGet: async (organizationStageModelId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationStageModelId' is not null or undefined
            assertParamExists('apiOrganizationStagesOrganizationStageModelIdGet', 'organizationStageModelId', organizationStageModelId)
            const localVarPath = `/api/OrganizationStages/{organizationStageModelId}`
                .replace(`{${"organizationStageModelId"}}`, encodeURIComponent(String(organizationStageModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets Issuer Stages by Organization Stage Pk
         * @param {string} organizationStagePk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStagePkIssuerstagesGet: async (organizationStagePk: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationStagePk' is not null or undefined
            assertParamExists('apiOrganizationStagesOrganizationStagePkIssuerstagesGet', 'organizationStagePk', organizationStagePk)
            const localVarPath = `/api/OrganizationStages/{organizationStagePk}/issuerstages`
                .replace(`{${"organizationStagePk"}}`, encodeURIComponent(String(organizationStagePk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns True if Organization Stage has pending Issuertages, Returns false if does not
         * @param {string} organizationStagePk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStagePkIssuerstagesHaspendingGet: async (organizationStagePk: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationStagePk' is not null or undefined
            assertParamExists('apiOrganizationStagesOrganizationStagePkIssuerstagesHaspendingGet', 'organizationStagePk', organizationStagePk)
            const localVarPath = `/api/OrganizationStages/{organizationStagePk}/issuerstages/haspending`
                .replace(`{${"organizationStagePk"}}`, encodeURIComponent(String(organizationStagePk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets Issuer Stage by Organization Stage Pk and issuer stage pk
         * @param {string} organizationStagePk 
         * @param {string} issuerStageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStagePkIssuerstagesIssuerStageIdGet: async (organizationStagePk: string, issuerStageId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationStagePk' is not null or undefined
            assertParamExists('apiOrganizationStagesOrganizationStagePkIssuerstagesIssuerStageIdGet', 'organizationStagePk', organizationStagePk)
            // verify required parameter 'issuerStageId' is not null or undefined
            assertParamExists('apiOrganizationStagesOrganizationStagePkIssuerstagesIssuerStageIdGet', 'issuerStageId', issuerStageId)
            const localVarPath = `/api/OrganizationStages/{organizationStagePk}/issuerstages/{issuerStageId}`
                .replace(`{${"organizationStagePk"}}`, encodeURIComponent(String(organizationStagePk)))
                .replace(`{${"issuerStageId"}}`, encodeURIComponent(String(issuerStageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates List of Issuer Stages
         * @param {string} organizationStagePk 
         * @param {Set<string>} [issuerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStagePkIssuerstagesPost: async (organizationStagePk: string, issuerName?: Set<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationStagePk' is not null or undefined
            assertParamExists('apiOrganizationStagesOrganizationStagePkIssuerstagesPost', 'organizationStagePk', organizationStagePk)
            const localVarPath = `/api/OrganizationStages/{organizationStagePk}/issuerstages`
                .replace(`{${"organizationStagePk"}}`, encodeURIComponent(String(organizationStagePk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (issuerName) {
                issuerName.forEach((element) => {
                    localVarFormParams.append('organizationsIssuersStage', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates Organization
         * @param {string} organizationStagePk 
         * @param {OrganizationStageProcessModel} [organizationStageProcessModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStagePkProcessPost: async (organizationStagePk: string, organizationStageProcessModel?: OrganizationStageProcessModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationStagePk' is not null or undefined
            assertParamExists('apiOrganizationStagesOrganizationStagePkProcessPost', 'organizationStagePk', organizationStagePk)
            const localVarPath = `/api/OrganizationStages/{organizationStagePk}/process`
                .replace(`{${"organizationStagePk"}}`, encodeURIComponent(String(organizationStagePk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationStageProcessModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updated Organization Stage
         * @param {string} organizationStagePk 
         * @param {OrganizationStageModelPartial} [organizationStageModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStagePkPut: async (organizationStagePk: string, organizationStageModelPartial?: OrganizationStageModelPartial, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationStagePk' is not null or undefined
            assertParamExists('apiOrganizationStagesOrganizationStagePkPut', 'organizationStagePk', organizationStagePk)
            const localVarPath = `/api/OrganizationStages/{organizationStagePk}`
                .replace(`{${"organizationStagePk"}}`, encodeURIComponent(String(organizationStagePk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationStageModelPartial, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates Organization Stage
         * @param {OrganizationStageModelPartial} [organizationStageModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesPost: async (organizationStageModelPartial?: OrganizationStageModelPartial, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OrganizationStages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationStageModelPartial, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationStagesApi - functional programming interface
 * @export
 */
export const OrganizationStagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationStagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets List of Organization Stage, for Organization Approval
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationStagesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationStageModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationStagesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes Organization Stage
         * @param {string} organizationStageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationStagesOrganizationStageIdDelete(organizationStageId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUserModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationStagesOrganizationStageIdDelete(organizationStageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets Organization Stage by Organization Stage Pk
         * @param {string} organizationStageModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationStagesOrganizationStageModelIdGet(organizationStageModelId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationStageModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationStagesOrganizationStageModelIdGet(organizationStageModelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets Issuer Stages by Organization Stage Pk
         * @param {string} organizationStagePk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationStagesOrganizationStagePkIssuerstagesGet(organizationStagePk: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IssuerStageModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationStagesOrganizationStagePkIssuerstagesGet(organizationStagePk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns True if Organization Stage has pending Issuertages, Returns false if does not
         * @param {string} organizationStagePk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationStagesOrganizationStagePkIssuerstagesHaspendingGet(organizationStagePk: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationStagesOrganizationStagePkIssuerstagesHaspendingGet(organizationStagePk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets Issuer Stage by Organization Stage Pk and issuer stage pk
         * @param {string} organizationStagePk 
         * @param {string} issuerStageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationStagesOrganizationStagePkIssuerstagesIssuerStageIdGet(organizationStagePk: string, issuerStageId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssuerStageModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationStagesOrganizationStagePkIssuerstagesIssuerStageIdGet(organizationStagePk, issuerStageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates List of Issuer Stages
         * @param {string} organizationStagePk 
         * @param {Set<string>} [issuerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationStagesOrganizationStagePkIssuerstagesPost(organizationStagePk: string, issuerName?: Set<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IssuerStageModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationStagesOrganizationStagePkIssuerstagesPost(organizationStagePk, issuerName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates Organization
         * @param {string} organizationStagePk 
         * @param {OrganizationStageProcessModel} [organizationStageProcessModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationStagesOrganizationStagePkProcessPost(organizationStagePk: string, organizationStageProcessModel?: OrganizationStageProcessModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationStagesOrganizationStagePkProcessPost(organizationStagePk, organizationStageProcessModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updated Organization Stage
         * @param {string} organizationStagePk 
         * @param {OrganizationStageModelPartial} [organizationStageModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationStagesOrganizationStagePkPut(organizationStagePk: string, organizationStageModelPartial?: OrganizationStageModelPartial, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationStageModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationStagesOrganizationStagePkPut(organizationStagePk, organizationStageModelPartial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates Organization Stage
         * @param {OrganizationStageModelPartial} [organizationStageModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationStagesPost(organizationStageModelPartial?: OrganizationStageModelPartial, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationStageModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationStagesPost(organizationStageModelPartial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationStagesApi - factory interface
 * @export
 */
export const OrganizationStagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationStagesApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets List of Organization Stage, for Organization Approval
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesGet(options?: any): AxiosPromise<Array<OrganizationStageModel>> {
            return localVarFp.apiOrganizationStagesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes Organization Stage
         * @param {string} organizationStageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStageIdDelete(organizationStageId: string, options?: any): AxiosPromise<OrganizationUserModel> {
            return localVarFp.apiOrganizationStagesOrganizationStageIdDelete(organizationStageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets Organization Stage by Organization Stage Pk
         * @param {string} organizationStageModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStageModelIdGet(organizationStageModelId: string, options?: any): AxiosPromise<OrganizationStageModel> {
            return localVarFp.apiOrganizationStagesOrganizationStageModelIdGet(organizationStageModelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets Issuer Stages by Organization Stage Pk
         * @param {string} organizationStagePk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStagePkIssuerstagesGet(organizationStagePk: string, options?: any): AxiosPromise<Array<IssuerStageModel>> {
            return localVarFp.apiOrganizationStagesOrganizationStagePkIssuerstagesGet(organizationStagePk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns True if Organization Stage has pending Issuertages, Returns false if does not
         * @param {string} organizationStagePk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStagePkIssuerstagesHaspendingGet(organizationStagePk: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiOrganizationStagesOrganizationStagePkIssuerstagesHaspendingGet(organizationStagePk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets Issuer Stage by Organization Stage Pk and issuer stage pk
         * @param {string} organizationStagePk 
         * @param {string} issuerStageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStagePkIssuerstagesIssuerStageIdGet(organizationStagePk: string, issuerStageId: string, options?: any): AxiosPromise<IssuerStageModel> {
            return localVarFp.apiOrganizationStagesOrganizationStagePkIssuerstagesIssuerStageIdGet(organizationStagePk, issuerStageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates List of Issuer Stages
         * @param {string} organizationStagePk 
         * @param {Set<string>} [issuerName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStagePkIssuerstagesPost(organizationStagePk: string, issuerName?: Set<string>, options?: any): AxiosPromise<Array<IssuerStageModel>> {
            return localVarFp.apiOrganizationStagesOrganizationStagePkIssuerstagesPost(organizationStagePk, issuerName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates Organization
         * @param {string} organizationStagePk 
         * @param {OrganizationStageProcessModel} [organizationStageProcessModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStagePkProcessPost(organizationStagePk: string, organizationStageProcessModel?: OrganizationStageProcessModel, options?: any): AxiosPromise<OrganizationModel> {
            return localVarFp.apiOrganizationStagesOrganizationStagePkProcessPost(organizationStagePk, organizationStageProcessModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updated Organization Stage
         * @param {string} organizationStagePk 
         * @param {OrganizationStageModelPartial} [organizationStageModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesOrganizationStagePkPut(organizationStagePk: string, organizationStageModelPartial?: OrganizationStageModelPartial, options?: any): AxiosPromise<OrganizationStageModel> {
            return localVarFp.apiOrganizationStagesOrganizationStagePkPut(organizationStagePk, organizationStageModelPartial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates Organization Stage
         * @param {OrganizationStageModelPartial} [organizationStageModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationStagesPost(organizationStageModelPartial?: OrganizationStageModelPartial, options?: any): AxiosPromise<OrganizationStageModel> {
            return localVarFp.apiOrganizationStagesPost(organizationStageModelPartial, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationStagesApi - interface
 * @export
 * @interface OrganizationStagesApi
 */
export interface OrganizationStagesApiInterface {
    /**
     * 
     * @summary Gets List of Organization Stage, for Organization Approval
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApiInterface
     */
    apiOrganizationStagesGet(options?: AxiosRequestConfig): AxiosPromise<Array<OrganizationStageModel>>;

    /**
     * 
     * @summary Deletes Organization Stage
     * @param {string} organizationStageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApiInterface
     */
    apiOrganizationStagesOrganizationStageIdDelete(organizationStageId: string, options?: AxiosRequestConfig): AxiosPromise<OrganizationUserModel>;

    /**
     * 
     * @summary Gets Organization Stage by Organization Stage Pk
     * @param {string} organizationStageModelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApiInterface
     */
    apiOrganizationStagesOrganizationStageModelIdGet(organizationStageModelId: string, options?: AxiosRequestConfig): AxiosPromise<OrganizationStageModel>;

    /**
     * 
     * @summary Gets Issuer Stages by Organization Stage Pk
     * @param {string} organizationStagePk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApiInterface
     */
    apiOrganizationStagesOrganizationStagePkIssuerstagesGet(organizationStagePk: string, options?: AxiosRequestConfig): AxiosPromise<Array<IssuerStageModel>>;

    /**
     * 
     * @summary Returns True if Organization Stage has pending Issuertages, Returns false if does not
     * @param {string} organizationStagePk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApiInterface
     */
    apiOrganizationStagesOrganizationStagePkIssuerstagesHaspendingGet(organizationStagePk: string, options?: AxiosRequestConfig): AxiosPromise<boolean>;

    /**
     * 
     * @summary Gets Issuer Stage by Organization Stage Pk and issuer stage pk
     * @param {string} organizationStagePk 
     * @param {string} issuerStageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApiInterface
     */
    apiOrganizationStagesOrganizationStagePkIssuerstagesIssuerStageIdGet(organizationStagePk: string, issuerStageId: string, options?: AxiosRequestConfig): AxiosPromise<IssuerStageModel>;

    /**
     * 
     * @summary Creates List of Issuer Stages
     * @param {string} organizationStagePk 
     * @param {Set<string>} [issuerName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApiInterface
     */
    apiOrganizationStagesOrganizationStagePkIssuerstagesPost(organizationStagePk: string, issuerName?: Set<string>, options?: AxiosRequestConfig): AxiosPromise<Array<IssuerStageModel>>;

    /**
     * 
     * @summary Creates Organization
     * @param {string} organizationStagePk 
     * @param {OrganizationStageProcessModel} [organizationStageProcessModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApiInterface
     */
    apiOrganizationStagesOrganizationStagePkProcessPost(organizationStagePk: string, organizationStageProcessModel?: OrganizationStageProcessModel, options?: AxiosRequestConfig): AxiosPromise<OrganizationModel>;

    /**
     * 
     * @summary Updated Organization Stage
     * @param {string} organizationStagePk 
     * @param {OrganizationStageModelPartial} [organizationStageModelPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApiInterface
     */
    apiOrganizationStagesOrganizationStagePkPut(organizationStagePk: string, organizationStageModelPartial?: OrganizationStageModelPartial, options?: AxiosRequestConfig): AxiosPromise<OrganizationStageModel>;

    /**
     * 
     * @summary Creates Organization Stage
     * @param {OrganizationStageModelPartial} [organizationStageModelPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApiInterface
     */
    apiOrganizationStagesPost(organizationStageModelPartial?: OrganizationStageModelPartial, options?: AxiosRequestConfig): AxiosPromise<OrganizationStageModel>;

}

/**
 * OrganizationStagesApi - object-oriented interface
 * @export
 * @class OrganizationStagesApi
 * @extends {BaseAPI}
 */
export class OrganizationStagesApi extends BaseAPI implements OrganizationStagesApiInterface {
    /**
     * 
     * @summary Gets List of Organization Stage, for Organization Approval
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApi
     */
    public apiOrganizationStagesGet(options?: AxiosRequestConfig) {
        return OrganizationStagesApiFp(this.configuration).apiOrganizationStagesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes Organization Stage
     * @param {string} organizationStageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApi
     */
    public apiOrganizationStagesOrganizationStageIdDelete(organizationStageId: string, options?: AxiosRequestConfig) {
        return OrganizationStagesApiFp(this.configuration).apiOrganizationStagesOrganizationStageIdDelete(organizationStageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets Organization Stage by Organization Stage Pk
     * @param {string} organizationStageModelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApi
     */
    public apiOrganizationStagesOrganizationStageModelIdGet(organizationStageModelId: string, options?: AxiosRequestConfig) {
        return OrganizationStagesApiFp(this.configuration).apiOrganizationStagesOrganizationStageModelIdGet(organizationStageModelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets Issuer Stages by Organization Stage Pk
     * @param {string} organizationStagePk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApi
     */
    public apiOrganizationStagesOrganizationStagePkIssuerstagesGet(organizationStagePk: string, options?: AxiosRequestConfig) {
        return OrganizationStagesApiFp(this.configuration).apiOrganizationStagesOrganizationStagePkIssuerstagesGet(organizationStagePk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns True if Organization Stage has pending Issuertages, Returns false if does not
     * @param {string} organizationStagePk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApi
     */
    public apiOrganizationStagesOrganizationStagePkIssuerstagesHaspendingGet(organizationStagePk: string, options?: AxiosRequestConfig) {
        return OrganizationStagesApiFp(this.configuration).apiOrganizationStagesOrganizationStagePkIssuerstagesHaspendingGet(organizationStagePk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets Issuer Stage by Organization Stage Pk and issuer stage pk
     * @param {string} organizationStagePk 
     * @param {string} issuerStageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApi
     */
    public apiOrganizationStagesOrganizationStagePkIssuerstagesIssuerStageIdGet(organizationStagePk: string, issuerStageId: string, options?: AxiosRequestConfig) {
        return OrganizationStagesApiFp(this.configuration).apiOrganizationStagesOrganizationStagePkIssuerstagesIssuerStageIdGet(organizationStagePk, issuerStageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates List of Issuer Stages
     * @param {string} organizationStagePk 
     * @param {Set<string>} [issuerName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApi
     */
    public apiOrganizationStagesOrganizationStagePkIssuerstagesPost(organizationStagePk: string, issuerName?: Set<string>, options?: AxiosRequestConfig) {
        return OrganizationStagesApiFp(this.configuration).apiOrganizationStagesOrganizationStagePkIssuerstagesPost(organizationStagePk, issuerName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates Organization
     * @param {string} organizationStagePk 
     * @param {OrganizationStageProcessModel} [organizationStageProcessModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApi
     */
    public apiOrganizationStagesOrganizationStagePkProcessPost(organizationStagePk: string, organizationStageProcessModel?: OrganizationStageProcessModel, options?: AxiosRequestConfig) {
        return OrganizationStagesApiFp(this.configuration).apiOrganizationStagesOrganizationStagePkProcessPost(organizationStagePk, organizationStageProcessModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updated Organization Stage
     * @param {string} organizationStagePk 
     * @param {OrganizationStageModelPartial} [organizationStageModelPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApi
     */
    public apiOrganizationStagesOrganizationStagePkPut(organizationStagePk: string, organizationStageModelPartial?: OrganizationStageModelPartial, options?: AxiosRequestConfig) {
        return OrganizationStagesApiFp(this.configuration).apiOrganizationStagesOrganizationStagePkPut(organizationStagePk, organizationStageModelPartial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates Organization Stage
     * @param {OrganizationStageModelPartial} [organizationStageModelPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationStagesApi
     */
    public apiOrganizationStagesPost(organizationStageModelPartial?: OrganizationStageModelPartial, options?: AxiosRequestConfig) {
        return OrganizationStagesApiFp(this.configuration).apiOrganizationStagesPost(organizationStageModelPartial, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationUserApi - axios parameter creator
 * @export
 */
export const OrganizationUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all users in the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationUserGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OrganizationUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets User by pk
         * @param {string} userPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationUserNfnUserUserPkGet: async (userPk: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userPk' is not null or undefined
            assertParamExists('apiOrganizationUserNfnUserUserPkGet', 'userPk', userPk)
            const localVarPath = `/api/OrganizationUser/NfnUser/{userPk}`
                .replace(`{${"userPk"}}`, encodeURIComponent(String(userPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary retrieves nwsf user information
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationUserNwsfinfoUsernameGet: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('apiOrganizationUserNwsfinfoUsernameGet', 'username', username)
            const localVarPath = `/api/OrganizationUser/nwsfinfo/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets users for organization by org pk
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationUserOrganizationPkGet: async (organizationPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationUserOrganizationPkGet', 'organizationPk', organizationPk)
            const localVarPath = `/api/OrganizationUser/{organizationPk}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates organization user
         * @param {number} organizationPk 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationUserOrganizationPkPost: async (organizationPk: number, username?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationUserOrganizationPkPost', 'organizationPk', organizationPk)
            const localVarPath = `/api/OrganizationUser/{organizationPk}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes Organization User
         * @param {string} userPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationUserUserPkDelete: async (userPk: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userPk' is not null or undefined
            assertParamExists('apiOrganizationUserUserPkDelete', 'userPk', userPk)
            const localVarPath = `/api/OrganizationUser/{userPk}`
                .replace(`{${"userPk"}}`, encodeURIComponent(String(userPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationUserApi - functional programming interface
 * @export
 */
export const OrganizationUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets all users in the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationUserGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationUserModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationUserGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets User by pk
         * @param {string} userPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationUserNfnUserUserPkGet(userPk: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUserModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationUserNfnUserUserPkGet(userPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary retrieves nwsf user information
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationUserNwsfinfoUsernameGet(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NwsfUserInfoModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationUserNwsfinfoUsernameGet(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets users for organization by org pk
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationUserOrganizationPkGet(organizationPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationUserModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationUserOrganizationPkGet(organizationPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates organization user
         * @param {number} organizationPk 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationUserOrganizationPkPost(organizationPk: number, username?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUserModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationUserOrganizationPkPost(organizationPk, username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes Organization User
         * @param {string} userPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationUserUserPkDelete(userPk: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationUserModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationUserUserPkDelete(userPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationUserApi - factory interface
 * @export
 */
export const OrganizationUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationUserApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets all users in the system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationUserGet(options?: any): AxiosPromise<Array<OrganizationUserModel>> {
            return localVarFp.apiOrganizationUserGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets User by pk
         * @param {string} userPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationUserNfnUserUserPkGet(userPk: string, options?: any): AxiosPromise<OrganizationUserModel> {
            return localVarFp.apiOrganizationUserNfnUserUserPkGet(userPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary retrieves nwsf user information
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationUserNwsfinfoUsernameGet(username: string, options?: any): AxiosPromise<NwsfUserInfoModel> {
            return localVarFp.apiOrganizationUserNwsfinfoUsernameGet(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets users for organization by org pk
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationUserOrganizationPkGet(organizationPk: number, options?: any): AxiosPromise<Array<OrganizationUserModel>> {
            return localVarFp.apiOrganizationUserOrganizationPkGet(organizationPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates organization user
         * @param {number} organizationPk 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationUserOrganizationPkPost(organizationPk: number, username?: string, options?: any): AxiosPromise<OrganizationUserModel> {
            return localVarFp.apiOrganizationUserOrganizationPkPost(organizationPk, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes Organization User
         * @param {string} userPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationUserUserPkDelete(userPk: string, options?: any): AxiosPromise<OrganizationUserModel> {
            return localVarFp.apiOrganizationUserUserPkDelete(userPk, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationUserApi - interface
 * @export
 * @interface OrganizationUserApi
 */
export interface OrganizationUserApiInterface {
    /**
     * 
     * @summary Gets all users in the system
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUserApiInterface
     */
    apiOrganizationUserGet(options?: AxiosRequestConfig): AxiosPromise<Array<OrganizationUserModel>>;

    /**
     * 
     * @summary Gets User by pk
     * @param {string} userPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUserApiInterface
     */
    apiOrganizationUserNfnUserUserPkGet(userPk: string, options?: AxiosRequestConfig): AxiosPromise<OrganizationUserModel>;

    /**
     * 
     * @summary retrieves nwsf user information
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUserApiInterface
     */
    apiOrganizationUserNwsfinfoUsernameGet(username: string, options?: AxiosRequestConfig): AxiosPromise<NwsfUserInfoModel>;

    /**
     * 
     * @summary Gets users for organization by org pk
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUserApiInterface
     */
    apiOrganizationUserOrganizationPkGet(organizationPk: number, options?: AxiosRequestConfig): AxiosPromise<Array<OrganizationUserModel>>;

    /**
     * 
     * @summary Creates organization user
     * @param {number} organizationPk 
     * @param {string} [username] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUserApiInterface
     */
    apiOrganizationUserOrganizationPkPost(organizationPk: number, username?: string, options?: AxiosRequestConfig): AxiosPromise<OrganizationUserModel>;

    /**
     * 
     * @summary Deletes Organization User
     * @param {string} userPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUserApiInterface
     */
    apiOrganizationUserUserPkDelete(userPk: string, options?: AxiosRequestConfig): AxiosPromise<OrganizationUserModel>;

}

/**
 * OrganizationUserApi - object-oriented interface
 * @export
 * @class OrganizationUserApi
 * @extends {BaseAPI}
 */
export class OrganizationUserApi extends BaseAPI implements OrganizationUserApiInterface {
    /**
     * 
     * @summary Gets all users in the system
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUserApi
     */
    public apiOrganizationUserGet(options?: AxiosRequestConfig) {
        return OrganizationUserApiFp(this.configuration).apiOrganizationUserGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets User by pk
     * @param {string} userPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUserApi
     */
    public apiOrganizationUserNfnUserUserPkGet(userPk: string, options?: AxiosRequestConfig) {
        return OrganizationUserApiFp(this.configuration).apiOrganizationUserNfnUserUserPkGet(userPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary retrieves nwsf user information
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUserApi
     */
    public apiOrganizationUserNwsfinfoUsernameGet(username: string, options?: AxiosRequestConfig) {
        return OrganizationUserApiFp(this.configuration).apiOrganizationUserNwsfinfoUsernameGet(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets users for organization by org pk
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUserApi
     */
    public apiOrganizationUserOrganizationPkGet(organizationPk: number, options?: AxiosRequestConfig) {
        return OrganizationUserApiFp(this.configuration).apiOrganizationUserOrganizationPkGet(organizationPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates organization user
     * @param {number} organizationPk 
     * @param {string} [username] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUserApi
     */
    public apiOrganizationUserOrganizationPkPost(organizationPk: number, username?: string, options?: AxiosRequestConfig) {
        return OrganizationUserApiFp(this.configuration).apiOrganizationUserOrganizationPkPost(organizationPk, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes Organization User
     * @param {string} userPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationUserApi
     */
    public apiOrganizationUserUserPkDelete(userPk: string, options?: AxiosRequestConfig) {
        return OrganizationUserApiFp(this.configuration).apiOrganizationUserUserPkDelete(userPk, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationsApi - axios parameter creator
 * @export
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets complete list of organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets organization clients by organization pk
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkClientsGet: async (organizationPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkClientsGet', 'organizationPk', organizationPk)
            const localVarPath = `/api/Organizations/{organizationPk}/clients`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes relation. Success= 204
         * @param {number} organizationPk 
         * @param {string} organizationIssuerRelationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdDelete: async (organizationPk: number, organizationIssuerRelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdDelete', 'organizationPk', organizationPk)
            // verify required parameter 'organizationIssuerRelationId' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdDelete', 'organizationIssuerRelationId', organizationIssuerRelationId)
            const localVarPath = `/api/Organizations/{organizationPk}/clients/{organizationIssuerRelationId}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)))
                .replace(`{${"organizationIssuerRelationId"}}`, encodeURIComponent(String(organizationIssuerRelationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets organization Client by organization pk and relation id
         * @param {number} organizationPk 
         * @param {string} organizationIssuerRelationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdGet: async (organizationPk: number, organizationIssuerRelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdGet', 'organizationPk', organizationPk)
            // verify required parameter 'organizationIssuerRelationId' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdGet', 'organizationIssuerRelationId', organizationIssuerRelationId)
            const localVarPath = `/api/Organizations/{organizationPk}/clients/{organizationIssuerRelationId}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)))
                .replace(`{${"organizationIssuerRelationId"}}`, encodeURIComponent(String(organizationIssuerRelationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates STATUS of organization Client by org id and relation id
         * @param {number} organizationPk 
         * @param {string} organizationIssuerRelationId 
         * @param {StatusBasicEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPatch: async (organizationPk: number, organizationIssuerRelationId: string, status?: StatusBasicEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPatch', 'organizationPk', organizationPk)
            // verify required parameter 'organizationIssuerRelationId' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPatch', 'organizationIssuerRelationId', organizationIssuerRelationId)
            const localVarPath = `/api/Organizations/{organizationPk}/clients/{organizationIssuerRelationId}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)))
                .replace(`{${"organizationIssuerRelationId"}}`, encodeURIComponent(String(organizationIssuerRelationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates organization Client by org id and relation id
         * @param {number} organizationPk 
         * @param {string} organizationIssuerRelationId 
         * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPut: async (organizationPk: number, organizationIssuerRelationId: string, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPut', 'organizationPk', organizationPk)
            // verify required parameter 'organizationIssuerRelationId' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPut', 'organizationIssuerRelationId', organizationIssuerRelationId)
            const localVarPath = `/api/Organizations/{organizationPk}/clients/{organizationIssuerRelationId}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)))
                .replace(`{${"organizationIssuerRelationId"}}`, encodeURIComponent(String(organizationIssuerRelationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationIssuerRelationModelPartial, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates organization Client
         * @param {number} organizationPk 
         * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkClientsPost: async (organizationPk: number, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkClientsPost', 'organizationPk', organizationPk)
            const localVarPath = `/api/Organizations/{organizationPk}/clients`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationIssuerRelationModelPartial, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets contact for organization by OrganizationID and contact id
         * @param {number} organizationPk 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkContactsContactIdGet: async (organizationPk: number, contactId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkContactsContactIdGet', 'organizationPk', organizationPk)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkContactsContactIdGet', 'contactId', contactId)
            const localVarPath = `/api/Organizations/{organizationPk}/contacts/{contactId}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)))
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Changes STATUS Of the contact for organization by OrganizationID and contact id
         * @param {number} organizationPk 
         * @param {number} contactId 
         * @param {StatusBasicEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkContactsContactIdPatch: async (organizationPk: number, contactId: number, status?: StatusBasicEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkContactsContactIdPatch', 'organizationPk', organizationPk)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkContactsContactIdPatch', 'contactId', contactId)
            const localVarPath = `/api/Organizations/{organizationPk}/contacts/{contactId}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)))
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates contact for organization by OrganizationID and contact id
         * @param {number} organizationPk 
         * @param {number} contactId 
         * @param {ContactModel} [contactModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkContactsContactIdPut: async (organizationPk: number, contactId: number, contactModel?: ContactModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkContactsContactIdPut', 'organizationPk', organizationPk)
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkContactsContactIdPut', 'contactId', contactId)
            const localVarPath = `/api/Organizations/{organizationPk}/contacts/{contactId}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)))
                .replace(`{${"contactId"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets contacts for organization by OrganizationID
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkContactsGet: async (organizationPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkContactsGet', 'organizationPk', organizationPk)
            const localVarPath = `/api/Organizations/{organizationPk}/contacts`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates new Contact for Organization
         * @param {number} organizationPk 
         * @param {ContactModel} [contactModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkContactsPost: async (organizationPk: number, contactModel?: ContactModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkContactsPost', 'organizationPk', organizationPk)
            const localVarPath = `/api/Organizations/{organizationPk}/contacts`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates OrganizationStages and returns Stages PK
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkCreatelinkPost: async (organizationPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkCreatelinkPost', 'organizationPk', organizationPk)
            const localVarPath = `/api/Organizations/{organizationPk}/createlink`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates new issuers, document optional
         * @param {number} organizationPk 
         * @param {Set<string>} [issuerName] 
         * @param {File} [formFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkCreatenewissuersPost: async (organizationPk: number, issuerName?: Set<string>, formFile?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkCreatenewissuersPost', 'organizationPk', organizationPk)
            const localVarPath = `/api/Organizations/{organizationPk}/createnewissuers`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (issuerName) {
                issuerName.forEach((element) => {
                    localVarFormParams.append('IssuerName', element as any);
                })
            }

    
            if (formFile !== undefined) { 
                localVarFormParams.append('formFile', formFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets organization by org id.
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkGet: async (organizationPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkGet', 'organizationPk', organizationPk)
            const localVarPath = `/api/Organizations/{organizationPk}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns True if Organization has pending Issuertages, Returns false if does not
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkHaspendingGet: async (organizationPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkHaspendingGet', 'organizationPk', organizationPk)
            const localVarPath = `/api/Organizations/{organizationPk}/haspending`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets List of Issuers for specific Organization By OrganizationID
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkIssuersGet: async (organizationPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkIssuersGet', 'organizationPk', organizationPk)
            const localVarPath = `/api/Organizations/{organizationPk}/Issuers`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets Issuer for specific Organization By OrganizationID and IssuerID
         * @param {number} organizationPk 
         * @param {number} issuerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkIssuersIssuerIdGet: async (organizationPk: number, issuerId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkIssuersIssuerIdGet', 'organizationPk', organizationPk)
            // verify required parameter 'issuerId' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkIssuersIssuerIdGet', 'issuerId', issuerId)
            const localVarPath = `/api/Organizations/{organizationPk}/Issuers/{issuerId}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)))
                .replace(`{${"issuerId"}}`, encodeURIComponent(String(issuerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates Specific Issuer STATUS
         * @param {number} organizationPk 
         * @param {number} issuerId 
         * @param {StatusBasicEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkIssuersIssuerIdPatch: async (organizationPk: number, issuerId: number, status?: StatusBasicEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkIssuersIssuerIdPatch', 'organizationPk', organizationPk)
            // verify required parameter 'issuerId' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkIssuersIssuerIdPatch', 'issuerId', issuerId)
            const localVarPath = `/api/Organizations/{organizationPk}/issuers/{issuerId}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)))
                .replace(`{${"issuerId"}}`, encodeURIComponent(String(issuerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates Specific Issuer
         * @param {number} organizationPk 
         * @param {number} issuerId 
         * @param {IssuerModel} [issuerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkIssuersIssuerIdPut: async (organizationPk: number, issuerId: number, issuerModel?: IssuerModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkIssuersIssuerIdPut', 'organizationPk', organizationPk)
            // verify required parameter 'issuerId' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkIssuersIssuerIdPut', 'issuerId', issuerId)
            const localVarPath = `/api/Organizations/{organizationPk}/issuers/{issuerId}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)))
                .replace(`{${"issuerId"}}`, encodeURIComponent(String(issuerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(issuerModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets List of StagedOrganizations created to add Affiliates for existing Organization
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkOrganizationStagesGet: async (organizationPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkOrganizationStagesGet', 'organizationPk', organizationPk)
            const localVarPath = `/api/Organizations/{organizationPk}/organizationStages`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates Organization
         * @param {number} organizationPk 
         * @param {OrganizationModel} [organizationModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkPut: async (organizationPk: number, organizationModel?: OrganizationModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkPut', 'organizationPk', organizationPk)
            const localVarPath = `/api/Organizations/{organizationPk}`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets user agreement for specific organization
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkUseragreementGet: async (organizationPk: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationPk' is not null or undefined
            assertParamExists('apiOrganizationsOrganizationPkUseragreementGet', 'organizationPk', organizationPk)
            const localVarPath = `/api/Organizations/{organizationPk}/useragreement`
                .replace(`{${"organizationPk"}}`, encodeURIComponent(String(organizationPk)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates new Organization approved. User Agreement is uploaded
         * @param {string} [organizationName] 
         * @param {string} [mPID] 
         * @param {Array<AdminRegion>} [regions] 
         * @param {string} [selectedRegionName] 
         * @param {string} [selectedRegionCode] 
         * @param {string} [currencyEnglishName] 
         * @param {string} [currencySymbol] 
         * @param {string} [nameEnglish] 
         * @param {string} [code3CurrencyISO4217] 
         * @param {string} [code2CountryLetterIso3166] 
         * @param {string} [code3CountryLetterIso3166] 
         * @param {File} [formFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsPost: async (organizationName?: string, mPID?: string, regions?: Array<AdminRegion>, selectedRegionName?: string, selectedRegionCode?: string, currencyEnglishName?: string, currencySymbol?: string, nameEnglish?: string, code3CurrencyISO4217?: string, code2CountryLetterIso3166?: string, code3CountryLetterIso3166?: string, formFile?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (organizationName !== undefined) { 
                localVarFormParams.append('OrganizationName', organizationName as any);
            }
    
            if (mPID !== undefined) { 
                localVarFormParams.append('MPID', mPID as any);
            }
                if (regions) {
                regions.forEach((element) => {
                    localVarFormParams.append('Regions', element as any);
                })
            }

    
            if (selectedRegionName !== undefined) { 
                localVarFormParams.append('SelectedRegion.Name', selectedRegionName as any);
            }
    
            if (selectedRegionCode !== undefined) { 
                localVarFormParams.append('SelectedRegion.Code', selectedRegionCode as any);
            }
    
            if (currencyEnglishName !== undefined) { 
                localVarFormParams.append('CurrencyEnglishName', currencyEnglishName as any);
            }
    
            if (currencySymbol !== undefined) { 
                localVarFormParams.append('CurrencySymbol', currencySymbol as any);
            }
    
            if (nameEnglish !== undefined) { 
                localVarFormParams.append('NameEnglish', nameEnglish as any);
            }
    
            if (code3CurrencyISO4217 !== undefined) { 
                localVarFormParams.append('Code3CurrencyISO4217', code3CurrencyISO4217 as any);
            }
    
            if (code2CountryLetterIso3166 !== undefined) { 
                localVarFormParams.append('Code2CountryLetterIso3166', code2CountryLetterIso3166 as any);
            }
    
            if (code3CountryLetterIso3166 !== undefined) { 
                localVarFormParams.append('Code3CountryLetterIso3166', code3CountryLetterIso3166 as any);
            }
    
            if (formFile !== undefined) { 
                localVarFormParams.append('formFile', formFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search fiels Orgname, MPID (exact). Paging is optional. Order by OrgName hardcodded.
         * @summary Search Organizations
         * @param {OrganizationIssuerSearchParams} [organizationIssuerSearchParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsSearchPost: async (organizationIssuerSearchParams?: OrganizationIssuerSearchParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Organizations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationIssuerSearchParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsApi - functional programming interface
 * @export
 */
export const OrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets complete list of organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets organization clients by organization pk
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkClientsGet(organizationPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationIssuerRelationModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkClientsGet(organizationPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes relation. Success= 204
         * @param {number} organizationPk 
         * @param {string} organizationIssuerRelationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdDelete(organizationPk: number, organizationIssuerRelationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationIssuerRelationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdDelete(organizationPk, organizationIssuerRelationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets organization Client by organization pk and relation id
         * @param {number} organizationPk 
         * @param {string} organizationIssuerRelationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdGet(organizationPk: number, organizationIssuerRelationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationIssuerRelationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdGet(organizationPk, organizationIssuerRelationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates STATUS of organization Client by org id and relation id
         * @param {number} organizationPk 
         * @param {string} organizationIssuerRelationId 
         * @param {StatusBasicEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPatch(organizationPk: number, organizationIssuerRelationId: string, status?: StatusBasicEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationIssuerRelationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPatch(organizationPk, organizationIssuerRelationId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates organization Client by org id and relation id
         * @param {number} organizationPk 
         * @param {string} organizationIssuerRelationId 
         * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPut(organizationPk: number, organizationIssuerRelationId: string, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationIssuerRelationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPut(organizationPk, organizationIssuerRelationId, organizationIssuerRelationModelPartial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates organization Client
         * @param {number} organizationPk 
         * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkClientsPost(organizationPk: number, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationIssuerRelationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkClientsPost(organizationPk, organizationIssuerRelationModelPartial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets contact for organization by OrganizationID and contact id
         * @param {number} organizationPk 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkContactsContactIdGet(organizationPk: number, contactId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkContactsContactIdGet(organizationPk, contactId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Changes STATUS Of the contact for organization by OrganizationID and contact id
         * @param {number} organizationPk 
         * @param {number} contactId 
         * @param {StatusBasicEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkContactsContactIdPatch(organizationPk: number, contactId: number, status?: StatusBasicEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkContactsContactIdPatch(organizationPk, contactId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates contact for organization by OrganizationID and contact id
         * @param {number} organizationPk 
         * @param {number} contactId 
         * @param {ContactModel} [contactModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkContactsContactIdPut(organizationPk: number, contactId: number, contactModel?: ContactModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkContactsContactIdPut(organizationPk, contactId, contactModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets contacts for organization by OrganizationID
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkContactsGet(organizationPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContactModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkContactsGet(organizationPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates new Contact for Organization
         * @param {number} organizationPk 
         * @param {ContactModel} [contactModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkContactsPost(organizationPk: number, contactModel?: ContactModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkContactsPost(organizationPk, contactModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates OrganizationStages and returns Stages PK
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkCreatelinkPost(organizationPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationStageModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkCreatelinkPost(organizationPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates new issuers, document optional
         * @param {number} organizationPk 
         * @param {Set<string>} [issuerName] 
         * @param {File} [formFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkCreatenewissuersPost(organizationPk: number, issuerName?: Set<string>, formFile?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkCreatenewissuersPost(organizationPk, issuerName, formFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets organization by org id.
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkGet(organizationPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkGet(organizationPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns True if Organization has pending Issuertages, Returns false if does not
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkHaspendingGet(organizationPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkHaspendingGet(organizationPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets List of Issuers for specific Organization By OrganizationID
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkIssuersGet(organizationPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IssuerModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkIssuersGet(organizationPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets Issuer for specific Organization By OrganizationID and IssuerID
         * @param {number} organizationPk 
         * @param {number} issuerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkIssuersIssuerIdGet(organizationPk: number, issuerId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssuerModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkIssuersIssuerIdGet(organizationPk, issuerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates Specific Issuer STATUS
         * @param {number} organizationPk 
         * @param {number} issuerId 
         * @param {StatusBasicEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkIssuersIssuerIdPatch(organizationPk: number, issuerId: number, status?: StatusBasicEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssuerModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkIssuersIssuerIdPatch(organizationPk, issuerId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates Specific Issuer
         * @param {number} organizationPk 
         * @param {number} issuerId 
         * @param {IssuerModel} [issuerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkIssuersIssuerIdPut(organizationPk: number, issuerId: number, issuerModel?: IssuerModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IssuerModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkIssuersIssuerIdPut(organizationPk, issuerId, issuerModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets List of StagedOrganizations created to add Affiliates for existing Organization
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkOrganizationStagesGet(organizationPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationStageModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkOrganizationStagesGet(organizationPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates Organization
         * @param {number} organizationPk 
         * @param {OrganizationModel} [organizationModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkPut(organizationPk: number, organizationModel?: OrganizationModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkPut(organizationPk, organizationModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets user agreement for specific organization
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsOrganizationPkUseragreementGet(organizationPk: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileStream>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsOrganizationPkUseragreementGet(organizationPk, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates new Organization approved. User Agreement is uploaded
         * @param {string} [organizationName] 
         * @param {string} [mPID] 
         * @param {Array<AdminRegion>} [regions] 
         * @param {string} [selectedRegionName] 
         * @param {string} [selectedRegionCode] 
         * @param {string} [currencyEnglishName] 
         * @param {string} [currencySymbol] 
         * @param {string} [nameEnglish] 
         * @param {string} [code3CurrencyISO4217] 
         * @param {string} [code2CountryLetterIso3166] 
         * @param {string} [code3CountryLetterIso3166] 
         * @param {File} [formFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsPost(organizationName?: string, mPID?: string, regions?: Array<AdminRegion>, selectedRegionName?: string, selectedRegionCode?: string, currencyEnglishName?: string, currencySymbol?: string, nameEnglish?: string, code3CurrencyISO4217?: string, code2CountryLetterIso3166?: string, code3CountryLetterIso3166?: string, formFile?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsPost(organizationName, mPID, regions, selectedRegionName, selectedRegionCode, currencyEnglishName, currencySymbol, nameEnglish, code3CurrencyISO4217, code2CountryLetterIso3166, code3CountryLetterIso3166, formFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Search fiels Orgname, MPID (exact). Paging is optional. Order by OrgName hardcodded.
         * @summary Search Organizations
         * @param {OrganizationIssuerSearchParams} [organizationIssuerSearchParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOrganizationsSearchPost(organizationIssuerSearchParams?: OrganizationIssuerSearchParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOrganizationsSearchPost(organizationIssuerSearchParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationsApi - factory interface
 * @export
 */
export const OrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets complete list of organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsGet(options?: any): AxiosPromise<Array<OrganizationModel>> {
            return localVarFp.apiOrganizationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets organization clients by organization pk
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkClientsGet(organizationPk: number, options?: any): AxiosPromise<Array<OrganizationIssuerRelationModel>> {
            return localVarFp.apiOrganizationsOrganizationPkClientsGet(organizationPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes relation. Success= 204
         * @param {number} organizationPk 
         * @param {string} organizationIssuerRelationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdDelete(organizationPk: number, organizationIssuerRelationId: string, options?: any): AxiosPromise<OrganizationIssuerRelationModel> {
            return localVarFp.apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdDelete(organizationPk, organizationIssuerRelationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets organization Client by organization pk and relation id
         * @param {number} organizationPk 
         * @param {string} organizationIssuerRelationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdGet(organizationPk: number, organizationIssuerRelationId: string, options?: any): AxiosPromise<OrganizationIssuerRelationModel> {
            return localVarFp.apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdGet(organizationPk, organizationIssuerRelationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates STATUS of organization Client by org id and relation id
         * @param {number} organizationPk 
         * @param {string} organizationIssuerRelationId 
         * @param {StatusBasicEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPatch(organizationPk: number, organizationIssuerRelationId: string, status?: StatusBasicEnum, options?: any): AxiosPromise<OrganizationIssuerRelationModel> {
            return localVarFp.apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPatch(organizationPk, organizationIssuerRelationId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates organization Client by org id and relation id
         * @param {number} organizationPk 
         * @param {string} organizationIssuerRelationId 
         * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPut(organizationPk: number, organizationIssuerRelationId: string, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: any): AxiosPromise<OrganizationIssuerRelationModel> {
            return localVarFp.apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPut(organizationPk, organizationIssuerRelationId, organizationIssuerRelationModelPartial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates organization Client
         * @param {number} organizationPk 
         * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkClientsPost(organizationPk: number, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: any): AxiosPromise<OrganizationIssuerRelationModel> {
            return localVarFp.apiOrganizationsOrganizationPkClientsPost(organizationPk, organizationIssuerRelationModelPartial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets contact for organization by OrganizationID and contact id
         * @param {number} organizationPk 
         * @param {number} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkContactsContactIdGet(organizationPk: number, contactId: number, options?: any): AxiosPromise<ContactModel> {
            return localVarFp.apiOrganizationsOrganizationPkContactsContactIdGet(organizationPk, contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Changes STATUS Of the contact for organization by OrganizationID and contact id
         * @param {number} organizationPk 
         * @param {number} contactId 
         * @param {StatusBasicEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkContactsContactIdPatch(organizationPk: number, contactId: number, status?: StatusBasicEnum, options?: any): AxiosPromise<ContactModel> {
            return localVarFp.apiOrganizationsOrganizationPkContactsContactIdPatch(organizationPk, contactId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates contact for organization by OrganizationID and contact id
         * @param {number} organizationPk 
         * @param {number} contactId 
         * @param {ContactModel} [contactModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkContactsContactIdPut(organizationPk: number, contactId: number, contactModel?: ContactModel, options?: any): AxiosPromise<ContactModel> {
            return localVarFp.apiOrganizationsOrganizationPkContactsContactIdPut(organizationPk, contactId, contactModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets contacts for organization by OrganizationID
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkContactsGet(organizationPk: number, options?: any): AxiosPromise<Array<ContactModel>> {
            return localVarFp.apiOrganizationsOrganizationPkContactsGet(organizationPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates new Contact for Organization
         * @param {number} organizationPk 
         * @param {ContactModel} [contactModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkContactsPost(organizationPk: number, contactModel?: ContactModel, options?: any): AxiosPromise<ContactModel> {
            return localVarFp.apiOrganizationsOrganizationPkContactsPost(organizationPk, contactModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates OrganizationStages and returns Stages PK
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkCreatelinkPost(organizationPk: number, options?: any): AxiosPromise<OrganizationStageModel> {
            return localVarFp.apiOrganizationsOrganizationPkCreatelinkPost(organizationPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates new issuers, document optional
         * @param {number} organizationPk 
         * @param {Set<string>} [issuerName] 
         * @param {File} [formFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkCreatenewissuersPost(organizationPk: number, issuerName?: Set<string>, formFile?: File, options?: any): AxiosPromise<OrganizationModel> {
            return localVarFp.apiOrganizationsOrganizationPkCreatenewissuersPost(organizationPk, issuerName, formFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets organization by org id.
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkGet(organizationPk: number, options?: any): AxiosPromise<OrganizationModel> {
            return localVarFp.apiOrganizationsOrganizationPkGet(organizationPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns True if Organization has pending Issuertages, Returns false if does not
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkHaspendingGet(organizationPk: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiOrganizationsOrganizationPkHaspendingGet(organizationPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets List of Issuers for specific Organization By OrganizationID
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkIssuersGet(organizationPk: number, options?: any): AxiosPromise<Array<IssuerModel>> {
            return localVarFp.apiOrganizationsOrganizationPkIssuersGet(organizationPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets Issuer for specific Organization By OrganizationID and IssuerID
         * @param {number} organizationPk 
         * @param {number} issuerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkIssuersIssuerIdGet(organizationPk: number, issuerId: number, options?: any): AxiosPromise<IssuerModel> {
            return localVarFp.apiOrganizationsOrganizationPkIssuersIssuerIdGet(organizationPk, issuerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates Specific Issuer STATUS
         * @param {number} organizationPk 
         * @param {number} issuerId 
         * @param {StatusBasicEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkIssuersIssuerIdPatch(organizationPk: number, issuerId: number, status?: StatusBasicEnum, options?: any): AxiosPromise<IssuerModel> {
            return localVarFp.apiOrganizationsOrganizationPkIssuersIssuerIdPatch(organizationPk, issuerId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates Specific Issuer
         * @param {number} organizationPk 
         * @param {number} issuerId 
         * @param {IssuerModel} [issuerModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkIssuersIssuerIdPut(organizationPk: number, issuerId: number, issuerModel?: IssuerModel, options?: any): AxiosPromise<IssuerModel> {
            return localVarFp.apiOrganizationsOrganizationPkIssuersIssuerIdPut(organizationPk, issuerId, issuerModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets List of StagedOrganizations created to add Affiliates for existing Organization
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkOrganizationStagesGet(organizationPk: number, options?: any): AxiosPromise<Array<OrganizationStageModel>> {
            return localVarFp.apiOrganizationsOrganizationPkOrganizationStagesGet(organizationPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates Organization
         * @param {number} organizationPk 
         * @param {OrganizationModel} [organizationModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkPut(organizationPk: number, organizationModel?: OrganizationModel, options?: any): AxiosPromise<void> {
            return localVarFp.apiOrganizationsOrganizationPkPut(organizationPk, organizationModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets user agreement for specific organization
         * @param {number} organizationPk 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsOrganizationPkUseragreementGet(organizationPk: number, options?: any): AxiosPromise<FileStream> {
            return localVarFp.apiOrganizationsOrganizationPkUseragreementGet(organizationPk, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates new Organization approved. User Agreement is uploaded
         * @param {string} [organizationName] 
         * @param {string} [mPID] 
         * @param {Array<AdminRegion>} [regions] 
         * @param {string} [selectedRegionName] 
         * @param {string} [selectedRegionCode] 
         * @param {string} [currencyEnglishName] 
         * @param {string} [currencySymbol] 
         * @param {string} [nameEnglish] 
         * @param {string} [code3CurrencyISO4217] 
         * @param {string} [code2CountryLetterIso3166] 
         * @param {string} [code3CountryLetterIso3166] 
         * @param {File} [formFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsPost(organizationName?: string, mPID?: string, regions?: Array<AdminRegion>, selectedRegionName?: string, selectedRegionCode?: string, currencyEnglishName?: string, currencySymbol?: string, nameEnglish?: string, code3CurrencyISO4217?: string, code2CountryLetterIso3166?: string, code3CountryLetterIso3166?: string, formFile?: File, options?: any): AxiosPromise<OrganizationModel> {
            return localVarFp.apiOrganizationsPost(organizationName, mPID, regions, selectedRegionName, selectedRegionCode, currencyEnglishName, currencySymbol, nameEnglish, code3CurrencyISO4217, code2CountryLetterIso3166, code3CountryLetterIso3166, formFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Search fiels Orgname, MPID (exact). Paging is optional. Order by OrgName hardcodded.
         * @summary Search Organizations
         * @param {OrganizationIssuerSearchParams} [organizationIssuerSearchParams] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOrganizationsSearchPost(organizationIssuerSearchParams?: OrganizationIssuerSearchParams, options?: any): AxiosPromise<Array<OrganizationModel>> {
            return localVarFp.apiOrganizationsSearchPost(organizationIssuerSearchParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationsApi - interface
 * @export
 * @interface OrganizationsApi
 */
export interface OrganizationsApiInterface {
    /**
     * 
     * @summary Gets complete list of organizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsGet(options?: AxiosRequestConfig): AxiosPromise<Array<OrganizationModel>>;

    /**
     * 
     * @summary Gets organization clients by organization pk
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkClientsGet(organizationPk: number, options?: AxiosRequestConfig): AxiosPromise<Array<OrganizationIssuerRelationModel>>;

    /**
     * 
     * @summary Deletes relation. Success= 204
     * @param {number} organizationPk 
     * @param {string} organizationIssuerRelationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdDelete(organizationPk: number, organizationIssuerRelationId: string, options?: AxiosRequestConfig): AxiosPromise<OrganizationIssuerRelationModel>;

    /**
     * 
     * @summary Gets organization Client by organization pk and relation id
     * @param {number} organizationPk 
     * @param {string} organizationIssuerRelationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdGet(organizationPk: number, organizationIssuerRelationId: string, options?: AxiosRequestConfig): AxiosPromise<OrganizationIssuerRelationModel>;

    /**
     * 
     * @summary Updates STATUS of organization Client by org id and relation id
     * @param {number} organizationPk 
     * @param {string} organizationIssuerRelationId 
     * @param {StatusBasicEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPatch(organizationPk: number, organizationIssuerRelationId: string, status?: StatusBasicEnum, options?: AxiosRequestConfig): AxiosPromise<OrganizationIssuerRelationModel>;

    /**
     * 
     * @summary Updates organization Client by org id and relation id
     * @param {number} organizationPk 
     * @param {string} organizationIssuerRelationId 
     * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPut(organizationPk: number, organizationIssuerRelationId: string, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: AxiosRequestConfig): AxiosPromise<OrganizationIssuerRelationModel>;

    /**
     * 
     * @summary Creates organization Client
     * @param {number} organizationPk 
     * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkClientsPost(organizationPk: number, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: AxiosRequestConfig): AxiosPromise<OrganizationIssuerRelationModel>;

    /**
     * 
     * @summary Gets contact for organization by OrganizationID and contact id
     * @param {number} organizationPk 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkContactsContactIdGet(organizationPk: number, contactId: number, options?: AxiosRequestConfig): AxiosPromise<ContactModel>;

    /**
     * 
     * @summary Changes STATUS Of the contact for organization by OrganizationID and contact id
     * @param {number} organizationPk 
     * @param {number} contactId 
     * @param {StatusBasicEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkContactsContactIdPatch(organizationPk: number, contactId: number, status?: StatusBasicEnum, options?: AxiosRequestConfig): AxiosPromise<ContactModel>;

    /**
     * 
     * @summary Updates contact for organization by OrganizationID and contact id
     * @param {number} organizationPk 
     * @param {number} contactId 
     * @param {ContactModel} [contactModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkContactsContactIdPut(organizationPk: number, contactId: number, contactModel?: ContactModel, options?: AxiosRequestConfig): AxiosPromise<ContactModel>;

    /**
     * 
     * @summary Gets contacts for organization by OrganizationID
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkContactsGet(organizationPk: number, options?: AxiosRequestConfig): AxiosPromise<Array<ContactModel>>;

    /**
     * 
     * @summary Creates new Contact for Organization
     * @param {number} organizationPk 
     * @param {ContactModel} [contactModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkContactsPost(organizationPk: number, contactModel?: ContactModel, options?: AxiosRequestConfig): AxiosPromise<ContactModel>;

    /**
     * 
     * @summary Creates OrganizationStages and returns Stages PK
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkCreatelinkPost(organizationPk: number, options?: AxiosRequestConfig): AxiosPromise<OrganizationStageModel>;

    /**
     * 
     * @summary Creates new issuers, document optional
     * @param {number} organizationPk 
     * @param {Set<string>} [issuerName] 
     * @param {File} [formFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkCreatenewissuersPost(organizationPk: number, issuerName?: Set<string>, formFile?: File, options?: AxiosRequestConfig): AxiosPromise<OrganizationModel>;

    /**
     * 
     * @summary Gets organization by org id.
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkGet(organizationPk: number, options?: AxiosRequestConfig): AxiosPromise<OrganizationModel>;

    /**
     * 
     * @summary Returns True if Organization has pending Issuertages, Returns false if does not
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkHaspendingGet(organizationPk: number, options?: AxiosRequestConfig): AxiosPromise<boolean>;

    /**
     * 
     * @summary Gets List of Issuers for specific Organization By OrganizationID
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkIssuersGet(organizationPk: number, options?: AxiosRequestConfig): AxiosPromise<Array<IssuerModel>>;

    /**
     * 
     * @summary Gets Issuer for specific Organization By OrganizationID and IssuerID
     * @param {number} organizationPk 
     * @param {number} issuerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkIssuersIssuerIdGet(organizationPk: number, issuerId: number, options?: AxiosRequestConfig): AxiosPromise<IssuerModel>;

    /**
     * 
     * @summary Updates Specific Issuer STATUS
     * @param {number} organizationPk 
     * @param {number} issuerId 
     * @param {StatusBasicEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkIssuersIssuerIdPatch(organizationPk: number, issuerId: number, status?: StatusBasicEnum, options?: AxiosRequestConfig): AxiosPromise<IssuerModel>;

    /**
     * 
     * @summary Updates Specific Issuer
     * @param {number} organizationPk 
     * @param {number} issuerId 
     * @param {IssuerModel} [issuerModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkIssuersIssuerIdPut(organizationPk: number, issuerId: number, issuerModel?: IssuerModel, options?: AxiosRequestConfig): AxiosPromise<IssuerModel>;

    /**
     * 
     * @summary Gets List of StagedOrganizations created to add Affiliates for existing Organization
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkOrganizationStagesGet(organizationPk: number, options?: AxiosRequestConfig): AxiosPromise<Array<OrganizationStageModel>>;

    /**
     * 
     * @summary Updates Organization
     * @param {number} organizationPk 
     * @param {OrganizationModel} [organizationModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkPut(organizationPk: number, organizationModel?: OrganizationModel, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Gets user agreement for specific organization
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsOrganizationPkUseragreementGet(organizationPk: number, options?: AxiosRequestConfig): AxiosPromise<FileStream>;

    /**
     * 
     * @summary Creates new Organization approved. User Agreement is uploaded
     * @param {string} [organizationName] 
     * @param {string} [mPID] 
     * @param {Array<AdminRegion>} [regions] 
     * @param {string} [selectedRegionName] 
     * @param {string} [selectedRegionCode] 
     * @param {string} [currencyEnglishName] 
     * @param {string} [currencySymbol] 
     * @param {string} [nameEnglish] 
     * @param {string} [code3CurrencyISO4217] 
     * @param {string} [code2CountryLetterIso3166] 
     * @param {string} [code3CountryLetterIso3166] 
     * @param {File} [formFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsPost(organizationName?: string, mPID?: string, regions?: Array<AdminRegion>, selectedRegionName?: string, selectedRegionCode?: string, currencyEnglishName?: string, currencySymbol?: string, nameEnglish?: string, code3CurrencyISO4217?: string, code2CountryLetterIso3166?: string, code3CountryLetterIso3166?: string, formFile?: File, options?: AxiosRequestConfig): AxiosPromise<OrganizationModel>;

    /**
     * Search fiels Orgname, MPID (exact). Paging is optional. Order by OrgName hardcodded.
     * @summary Search Organizations
     * @param {OrganizationIssuerSearchParams} [organizationIssuerSearchParams] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    apiOrganizationsSearchPost(organizationIssuerSearchParams?: OrganizationIssuerSearchParams, options?: AxiosRequestConfig): AxiosPromise<Array<OrganizationModel>>;

}

/**
 * OrganizationsApi - object-oriented interface
 * @export
 * @class OrganizationsApi
 * @extends {BaseAPI}
 */
export class OrganizationsApi extends BaseAPI implements OrganizationsApiInterface {
    /**
     * 
     * @summary Gets complete list of organizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsGet(options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets organization clients by organization pk
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkClientsGet(organizationPk: number, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkClientsGet(organizationPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes relation. Success= 204
     * @param {number} organizationPk 
     * @param {string} organizationIssuerRelationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdDelete(organizationPk: number, organizationIssuerRelationId: string, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdDelete(organizationPk, organizationIssuerRelationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets organization Client by organization pk and relation id
     * @param {number} organizationPk 
     * @param {string} organizationIssuerRelationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdGet(organizationPk: number, organizationIssuerRelationId: string, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdGet(organizationPk, organizationIssuerRelationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates STATUS of organization Client by org id and relation id
     * @param {number} organizationPk 
     * @param {string} organizationIssuerRelationId 
     * @param {StatusBasicEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPatch(organizationPk: number, organizationIssuerRelationId: string, status?: StatusBasicEnum, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPatch(organizationPk, organizationIssuerRelationId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates organization Client by org id and relation id
     * @param {number} organizationPk 
     * @param {string} organizationIssuerRelationId 
     * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPut(organizationPk: number, organizationIssuerRelationId: string, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkClientsOrganizationIssuerRelationIdPut(organizationPk, organizationIssuerRelationId, organizationIssuerRelationModelPartial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates organization Client
     * @param {number} organizationPk 
     * @param {OrganizationIssuerRelationModelPartial} [organizationIssuerRelationModelPartial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkClientsPost(organizationPk: number, organizationIssuerRelationModelPartial?: OrganizationIssuerRelationModelPartial, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkClientsPost(organizationPk, organizationIssuerRelationModelPartial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets contact for organization by OrganizationID and contact id
     * @param {number} organizationPk 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkContactsContactIdGet(organizationPk: number, contactId: number, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkContactsContactIdGet(organizationPk, contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Changes STATUS Of the contact for organization by OrganizationID and contact id
     * @param {number} organizationPk 
     * @param {number} contactId 
     * @param {StatusBasicEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkContactsContactIdPatch(organizationPk: number, contactId: number, status?: StatusBasicEnum, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkContactsContactIdPatch(organizationPk, contactId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates contact for organization by OrganizationID and contact id
     * @param {number} organizationPk 
     * @param {number} contactId 
     * @param {ContactModel} [contactModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkContactsContactIdPut(organizationPk: number, contactId: number, contactModel?: ContactModel, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkContactsContactIdPut(organizationPk, contactId, contactModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets contacts for organization by OrganizationID
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkContactsGet(organizationPk: number, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkContactsGet(organizationPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates new Contact for Organization
     * @param {number} organizationPk 
     * @param {ContactModel} [contactModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkContactsPost(organizationPk: number, contactModel?: ContactModel, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkContactsPost(organizationPk, contactModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates OrganizationStages and returns Stages PK
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkCreatelinkPost(organizationPk: number, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkCreatelinkPost(organizationPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates new issuers, document optional
     * @param {number} organizationPk 
     * @param {Set<string>} [issuerName] 
     * @param {File} [formFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkCreatenewissuersPost(organizationPk: number, issuerName?: Set<string>, formFile?: File, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkCreatenewissuersPost(organizationPk, issuerName, formFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets organization by org id.
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkGet(organizationPk: number, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkGet(organizationPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns True if Organization has pending Issuertages, Returns false if does not
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkHaspendingGet(organizationPk: number, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkHaspendingGet(organizationPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets List of Issuers for specific Organization By OrganizationID
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkIssuersGet(organizationPk: number, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkIssuersGet(organizationPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets Issuer for specific Organization By OrganizationID and IssuerID
     * @param {number} organizationPk 
     * @param {number} issuerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkIssuersIssuerIdGet(organizationPk: number, issuerId: number, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkIssuersIssuerIdGet(organizationPk, issuerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates Specific Issuer STATUS
     * @param {number} organizationPk 
     * @param {number} issuerId 
     * @param {StatusBasicEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkIssuersIssuerIdPatch(organizationPk: number, issuerId: number, status?: StatusBasicEnum, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkIssuersIssuerIdPatch(organizationPk, issuerId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates Specific Issuer
     * @param {number} organizationPk 
     * @param {number} issuerId 
     * @param {IssuerModel} [issuerModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkIssuersIssuerIdPut(organizationPk: number, issuerId: number, issuerModel?: IssuerModel, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkIssuersIssuerIdPut(organizationPk, issuerId, issuerModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets List of StagedOrganizations created to add Affiliates for existing Organization
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkOrganizationStagesGet(organizationPk: number, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkOrganizationStagesGet(organizationPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates Organization
     * @param {number} organizationPk 
     * @param {OrganizationModel} [organizationModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkPut(organizationPk: number, organizationModel?: OrganizationModel, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkPut(organizationPk, organizationModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets user agreement for specific organization
     * @param {number} organizationPk 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsOrganizationPkUseragreementGet(organizationPk: number, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsOrganizationPkUseragreementGet(organizationPk, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates new Organization approved. User Agreement is uploaded
     * @param {string} [organizationName] 
     * @param {string} [mPID] 
     * @param {Array<AdminRegion>} [regions] 
     * @param {string} [selectedRegionName] 
     * @param {string} [selectedRegionCode] 
     * @param {string} [currencyEnglishName] 
     * @param {string} [currencySymbol] 
     * @param {string} [nameEnglish] 
     * @param {string} [code3CurrencyISO4217] 
     * @param {string} [code2CountryLetterIso3166] 
     * @param {string} [code3CountryLetterIso3166] 
     * @param {File} [formFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsPost(organizationName?: string, mPID?: string, regions?: Array<AdminRegion>, selectedRegionName?: string, selectedRegionCode?: string, currencyEnglishName?: string, currencySymbol?: string, nameEnglish?: string, code3CurrencyISO4217?: string, code2CountryLetterIso3166?: string, code3CountryLetterIso3166?: string, formFile?: File, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsPost(organizationName, mPID, regions, selectedRegionName, selectedRegionCode, currencyEnglishName, currencySymbol, nameEnglish, code3CurrencyISO4217, code2CountryLetterIso3166, code3CountryLetterIso3166, formFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search fiels Orgname, MPID (exact). Paging is optional. Order by OrgName hardcodded.
     * @summary Search Organizations
     * @param {OrganizationIssuerSearchParams} [organizationIssuerSearchParams] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public apiOrganizationsSearchPost(organizationIssuerSearchParams?: OrganizationIssuerSearchParams, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).apiOrganizationsSearchPost(organizationIssuerSearchParams, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * issuerid required for internal users, in all other users it will be ignored
         * @summary returns list of products avaialble to user.
         * @param {number} issuerid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIssuerIssueridGet: async (issuerid: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerid' is not null or undefined
            assertParamExists('apiProductIssuerIssueridGet', 'issuerid', issuerid)
            const localVarPath = `/api/Product/issuer/{issuerid}`
                .replace(`{${"issuerid"}}`, encodeURIComponent(String(issuerid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns List Of pending Documents available to user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPendingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Product/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary creates a new product
         * @param {ProductModel} [productModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPost: async (productModel?: ProductModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Product Can be deleted if there are not Instruments assigned to it
         * @summary Deletes Product.
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductProductIdDelete: async (productId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiProductProductIdDelete', 'productId', productId)
            const localVarPath = `/api/Product/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates Specific Product STATUS
         * @param {number} productId 
         * @param {StatusAprovalSimplifiedEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductProductIdPatch: async (productId: number, status?: StatusAprovalSimplifiedEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('apiProductProductIdPatch', 'productId', productId)
            const localVarPath = `/api/Product/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * issuerid required for internal users, in all other users it will be ignored
         * @summary Searches Product , by symbol, product name or product id
         * @param {string} [value] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductSearchGet: async (value?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Product/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns product symbol for given issuer
         * @param {number} issuerId 
         * @param {string} [partial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductSymbolIssuerIdPost: async (issuerId: number, partial?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerId' is not null or undefined
            assertParamExists('apiProductSymbolIssuerIdPost', 'issuerId', issuerId)
            const localVarPath = `/api/Product/symbol/{issuerId}`
                .replace(`{${"issuerId"}}`, encodeURIComponent(String(issuerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (partial !== undefined) {
                localVarQueryParameter['partial'] = partial;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates Specific Product
         * @param {ProductModel} [productModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdatePut: async (productModel?: ProductModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Product/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductApiAxiosParamCreator(configuration)
    return {
        /**
         * issuerid required for internal users, in all other users it will be ignored
         * @summary returns list of products avaialble to user.
         * @param {number} issuerid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductIssuerIssueridGet(issuerid: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductIssuerIssueridGet(issuerid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns List Of pending Documents available to user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPendingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPendingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary creates a new product
         * @param {ProductModel} [productModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductPost(productModel?: ProductModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductPost(productModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Product Can be deleted if there are not Instruments assigned to it
         * @summary Deletes Product.
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductProductIdDelete(productId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductProductIdDelete(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates Specific Product STATUS
         * @param {number} productId 
         * @param {StatusAprovalSimplifiedEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductProductIdPatch(productId: number, status?: StatusAprovalSimplifiedEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductProductIdPatch(productId, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * issuerid required for internal users, in all other users it will be ignored
         * @summary Searches Product , by symbol, product name or product id
         * @param {string} [value] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductSearchGet(value?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductSearchGet(value, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary returns product symbol for given issuer
         * @param {number} issuerId 
         * @param {string} [partial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductSymbolIssuerIdPost(issuerId: number, partial?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductSymbolIssuerIdPost(issuerId, partial, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates Specific Product
         * @param {ProductModel} [productModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductUpdatePut(productModel?: ProductModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductUpdatePut(productModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductApiFp(configuration)
    return {
        /**
         * issuerid required for internal users, in all other users it will be ignored
         * @summary returns list of products avaialble to user.
         * @param {number} issuerid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductIssuerIssueridGet(issuerid: number, options?: any): AxiosPromise<Array<ProductModel>> {
            return localVarFp.apiProductIssuerIssueridGet(issuerid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns List Of pending Documents available to user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPendingGet(options?: any): AxiosPromise<Array<ProductModel>> {
            return localVarFp.apiProductPendingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary creates a new product
         * @param {ProductModel} [productModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductPost(productModel?: ProductModel, options?: any): AxiosPromise<ProductModel> {
            return localVarFp.apiProductPost(productModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Product Can be deleted if there are not Instruments assigned to it
         * @summary Deletes Product.
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductProductIdDelete(productId: number, options?: any): AxiosPromise<ProductModel> {
            return localVarFp.apiProductProductIdDelete(productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates Specific Product STATUS
         * @param {number} productId 
         * @param {StatusAprovalSimplifiedEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductProductIdPatch(productId: number, status?: StatusAprovalSimplifiedEnum, options?: any): AxiosPromise<ProductModel> {
            return localVarFp.apiProductProductIdPatch(productId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * issuerid required for internal users, in all other users it will be ignored
         * @summary Searches Product , by symbol, product name or product id
         * @param {string} [value] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductSearchGet(value?: string, options?: any): AxiosPromise<Array<ProductModel>> {
            return localVarFp.apiProductSearchGet(value, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns product symbol for given issuer
         * @param {number} issuerId 
         * @param {string} [partial] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductSymbolIssuerIdPost(issuerId: number, partial?: string, options?: any): AxiosPromise<string> {
            return localVarFp.apiProductSymbolIssuerIdPost(issuerId, partial, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates Specific Product
         * @param {ProductModel} [productModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductUpdatePut(productModel?: ProductModel, options?: any): AxiosPromise<ProductModel> {
            return localVarFp.apiProductUpdatePut(productModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductApi - interface
 * @export
 * @interface ProductApi
 */
export interface ProductApiInterface {
    /**
     * issuerid required for internal users, in all other users it will be ignored
     * @summary returns list of products avaialble to user.
     * @param {number} issuerid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApiInterface
     */
    apiProductIssuerIssueridGet(issuerid: number, options?: AxiosRequestConfig): AxiosPromise<Array<ProductModel>>;

    /**
     * 
     * @summary Returns List Of pending Documents available to user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApiInterface
     */
    apiProductPendingGet(options?: AxiosRequestConfig): AxiosPromise<Array<ProductModel>>;

    /**
     * 
     * @summary creates a new product
     * @param {ProductModel} [productModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApiInterface
     */
    apiProductPost(productModel?: ProductModel, options?: AxiosRequestConfig): AxiosPromise<ProductModel>;

    /**
     * Product Can be deleted if there are not Instruments assigned to it
     * @summary Deletes Product.
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApiInterface
     */
    apiProductProductIdDelete(productId: number, options?: AxiosRequestConfig): AxiosPromise<ProductModel>;

    /**
     * 
     * @summary Updates Specific Product STATUS
     * @param {number} productId 
     * @param {StatusAprovalSimplifiedEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApiInterface
     */
    apiProductProductIdPatch(productId: number, status?: StatusAprovalSimplifiedEnum, options?: AxiosRequestConfig): AxiosPromise<ProductModel>;

    /**
     * issuerid required for internal users, in all other users it will be ignored
     * @summary Searches Product , by symbol, product name or product id
     * @param {string} [value] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApiInterface
     */
    apiProductSearchGet(value?: string, options?: AxiosRequestConfig): AxiosPromise<Array<ProductModel>>;

    /**
     * 
     * @summary returns product symbol for given issuer
     * @param {number} issuerId 
     * @param {string} [partial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApiInterface
     */
    apiProductSymbolIssuerIdPost(issuerId: number, partial?: string, options?: AxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Updates Specific Product
     * @param {ProductModel} [productModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApiInterface
     */
    apiProductUpdatePut(productModel?: ProductModel, options?: AxiosRequestConfig): AxiosPromise<ProductModel>;

}

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI implements ProductApiInterface {
    /**
     * issuerid required for internal users, in all other users it will be ignored
     * @summary returns list of products avaialble to user.
     * @param {number} issuerid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductIssuerIssueridGet(issuerid: number, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).apiProductIssuerIssueridGet(issuerid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns List Of pending Documents available to user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductPendingGet(options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).apiProductPendingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary creates a new product
     * @param {ProductModel} [productModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductPost(productModel?: ProductModel, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).apiProductPost(productModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Product Can be deleted if there are not Instruments assigned to it
     * @summary Deletes Product.
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductProductIdDelete(productId: number, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).apiProductProductIdDelete(productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates Specific Product STATUS
     * @param {number} productId 
     * @param {StatusAprovalSimplifiedEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductProductIdPatch(productId: number, status?: StatusAprovalSimplifiedEnum, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).apiProductProductIdPatch(productId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * issuerid required for internal users, in all other users it will be ignored
     * @summary Searches Product , by symbol, product name or product id
     * @param {string} [value] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductSearchGet(value?: string, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).apiProductSearchGet(value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns product symbol for given issuer
     * @param {number} issuerId 
     * @param {string} [partial] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductSymbolIssuerIdPost(issuerId: number, partial?: string, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).apiProductSymbolIssuerIdPost(issuerId, partial, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates Specific Product
     * @param {ProductModel} [productModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public apiProductUpdatePut(productModel?: ProductModel, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).apiProductUpdatePut(productModel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UtilitiesApi - axios parameter creator
 * @export
 */
export const UtilitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Application types with Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesApplicationTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Utilities/ApplicationTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list of countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesCountriesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Utilities/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Document types with Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesDocumentTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Utilities/DocumentTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns values for dropdowns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesDropdownContentGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Utilities/DropdownContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesModelsettingsGet: async (model?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Utilities/modelsettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary PortfolioAllocationType for Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesPortfolioAllocationTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Utilities/PortfolioAllocationTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Product types with Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesProductTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Utilities/ProductTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesRefreshSettingsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Utilities/RefreshSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate field Should be called when Validator is known and it would bypass conditional validation.  UI should make dession if this validation shuld be called
         * @param {string} validatorName Name opf the validator type
         * @param {string} modelName Name of the model type
         * @param {boolean} allowNullorEmpty allow empty field
         * @param {string} fieldName name of the field
         * @param {any} [body] Serialized Json Model to be validated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesValidateFieldValidatorNameModelNameFieldNameAllowNullorEmptyPost: async (validatorName: string, modelName: string, allowNullorEmpty: boolean, fieldName: string, body?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validatorName' is not null or undefined
            assertParamExists('apiUtilitiesValidateFieldValidatorNameModelNameFieldNameAllowNullorEmptyPost', 'validatorName', validatorName)
            // verify required parameter 'modelName' is not null or undefined
            assertParamExists('apiUtilitiesValidateFieldValidatorNameModelNameFieldNameAllowNullorEmptyPost', 'modelName', modelName)
            // verify required parameter 'allowNullorEmpty' is not null or undefined
            assertParamExists('apiUtilitiesValidateFieldValidatorNameModelNameFieldNameAllowNullorEmptyPost', 'allowNullorEmpty', allowNullorEmpty)
            // verify required parameter 'fieldName' is not null or undefined
            assertParamExists('apiUtilitiesValidateFieldValidatorNameModelNameFieldNameAllowNullorEmptyPost', 'fieldName', fieldName)
            const localVarPath = `/api/Utilities/validateField/{validatorName}/{modelName}/{fieldName}/{allowNullorEmpty}`
                .replace(`{${"validatorName"}}`, encodeURIComponent(String(validatorName)))
                .replace(`{${"modelName"}}`, encodeURIComponent(String(modelName)))
                .replace(`{${"allowNullorEmpty"}}`, encodeURIComponent(String(allowNullorEmpty)))
                .replace(`{${"fieldName"}}`, encodeURIComponent(String(fieldName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This endpoint should be envokend when Validator is unknown.  All validators which applied to the specific property of the   Model will be envoked conditionaly based on Advanced validator Settings.
         * @param {string} modelName Name of the model type
         * @param {string} propertyName name of the property
         * @param {any} [body] Serialized Json Model to be validated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesValidatePropertyModelNamePropertyNamePost: async (modelName: string, propertyName: string, body?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'modelName' is not null or undefined
            assertParamExists('apiUtilitiesValidatePropertyModelNamePropertyNamePost', 'modelName', modelName)
            // verify required parameter 'propertyName' is not null or undefined
            assertParamExists('apiUtilitiesValidatePropertyModelNamePropertyNamePost', 'propertyName', propertyName)
            const localVarPath = `/api/Utilities/validateProperty/{modelName}/{propertyName}`
                .replace(`{${"modelName"}}`, encodeURIComponent(String(modelName)))
                .replace(`{${"propertyName"}}`, encodeURIComponent(String(propertyName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilitiesApi - functional programming interface
 * @export
 */
export const UtilitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Application types with Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilitiesApplicationTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApplicationTypeEnumEnumWithDescription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilitiesApplicationTypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary list of countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilitiesCountriesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilitiesCountriesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Document types with Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilitiesDocumentTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentTypeEnumEnumWithDescription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilitiesDocumentTypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns values for dropdowns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilitiesDropdownContentGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<IDescription>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilitiesDropdownContentGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilitiesModelsettingsGet(model?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModelSettings>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilitiesModelsettingsGet(model, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary PortfolioAllocationType for Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilitiesPortfolioAllocationTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PortfolioAllocationType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilitiesPortfolioAllocationTypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Product types with Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilitiesProductTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductTypeEnumEnumWithDescription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilitiesProductTypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilitiesRefreshSettingsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilitiesRefreshSettingsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validate field Should be called when Validator is known and it would bypass conditional validation.  UI should make dession if this validation shuld be called
         * @param {string} validatorName Name opf the validator type
         * @param {string} modelName Name of the model type
         * @param {boolean} allowNullorEmpty allow empty field
         * @param {string} fieldName name of the field
         * @param {any} [body] Serialized Json Model to be validated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilitiesValidateFieldValidatorNameModelNameFieldNameAllowNullorEmptyPost(validatorName: string, modelName: string, allowNullorEmpty: boolean, fieldName: string, body?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilitiesValidateFieldValidatorNameModelNameFieldNameAllowNullorEmptyPost(validatorName, modelName, allowNullorEmpty, fieldName, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary This endpoint should be envokend when Validator is unknown.  All validators which applied to the specific property of the   Model will be envoked conditionaly based on Advanced validator Settings.
         * @param {string} modelName Name of the model type
         * @param {string} propertyName name of the property
         * @param {any} [body] Serialized Json Model to be validated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUtilitiesValidatePropertyModelNamePropertyNamePost(modelName: string, propertyName: string, body?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUtilitiesValidatePropertyModelNamePropertyNamePost(modelName, propertyName, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UtilitiesApi - factory interface
 * @export
 */
export const UtilitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilitiesApiFp(configuration)
    return {
        /**
         * 
         * @summary Application types with Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesApplicationTypesGet(options?: any): AxiosPromise<Array<ApplicationTypeEnumEnumWithDescription>> {
            return localVarFp.apiUtilitiesApplicationTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list of countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesCountriesGet(options?: any): AxiosPromise<CountryList> {
            return localVarFp.apiUtilitiesCountriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Document types with Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesDocumentTypesGet(options?: any): AxiosPromise<Array<DocumentTypeEnumEnumWithDescription>> {
            return localVarFp.apiUtilitiesDocumentTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns values for dropdowns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesDropdownContentGet(options?: any): AxiosPromise<{ [key: string]: Array<IDescription>; }> {
            return localVarFp.apiUtilitiesDropdownContentGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesModelsettingsGet(model?: string, options?: any): AxiosPromise<Array<ModelSettings>> {
            return localVarFp.apiUtilitiesModelsettingsGet(model, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary PortfolioAllocationType for Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesPortfolioAllocationTypesGet(options?: any): AxiosPromise<Array<PortfolioAllocationType>> {
            return localVarFp.apiUtilitiesPortfolioAllocationTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Product types with Description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesProductTypesGet(options?: any): AxiosPromise<Array<ProductTypeEnumEnumWithDescription>> {
            return localVarFp.apiUtilitiesProductTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesRefreshSettingsGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiUtilitiesRefreshSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate field Should be called when Validator is known and it would bypass conditional validation.  UI should make dession if this validation shuld be called
         * @param {string} validatorName Name opf the validator type
         * @param {string} modelName Name of the model type
         * @param {boolean} allowNullorEmpty allow empty field
         * @param {string} fieldName name of the field
         * @param {any} [body] Serialized Json Model to be validated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesValidateFieldValidatorNameModelNameFieldNameAllowNullorEmptyPost(validatorName: string, modelName: string, allowNullorEmpty: boolean, fieldName: string, body?: any, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiUtilitiesValidateFieldValidatorNameModelNameFieldNameAllowNullorEmptyPost(validatorName, modelName, allowNullorEmpty, fieldName, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This endpoint should be envokend when Validator is unknown.  All validators which applied to the specific property of the   Model will be envoked conditionaly based on Advanced validator Settings.
         * @param {string} modelName Name of the model type
         * @param {string} propertyName name of the property
         * @param {any} [body] Serialized Json Model to be validated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilitiesValidatePropertyModelNamePropertyNamePost(modelName: string, propertyName: string, body?: any, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiUtilitiesValidatePropertyModelNamePropertyNamePost(modelName, propertyName, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UtilitiesApi - interface
 * @export
 * @interface UtilitiesApi
 */
export interface UtilitiesApiInterface {
    /**
     * 
     * @summary Application types with Description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiInterface
     */
    apiUtilitiesApplicationTypesGet(options?: AxiosRequestConfig): AxiosPromise<Array<ApplicationTypeEnumEnumWithDescription>>;

    /**
     * 
     * @summary list of countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiInterface
     */
    apiUtilitiesCountriesGet(options?: AxiosRequestConfig): AxiosPromise<CountryList>;

    /**
     * 
     * @summary Document types with Description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiInterface
     */
    apiUtilitiesDocumentTypesGet(options?: AxiosRequestConfig): AxiosPromise<Array<DocumentTypeEnumEnumWithDescription>>;

    /**
     * 
     * @summary Returns values for dropdowns
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiInterface
     */
    apiUtilitiesDropdownContentGet(options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: Array<IDescription>; }>;

    /**
     * 
     * @param {string} [model] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiInterface
     */
    apiUtilitiesModelsettingsGet(model?: string, options?: AxiosRequestConfig): AxiosPromise<Array<ModelSettings>>;

    /**
     * 
     * @summary PortfolioAllocationType for Product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiInterface
     */
    apiUtilitiesPortfolioAllocationTypesGet(options?: AxiosRequestConfig): AxiosPromise<Array<PortfolioAllocationType>>;

    /**
     * 
     * @summary Product types with Description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiInterface
     */
    apiUtilitiesProductTypesGet(options?: AxiosRequestConfig): AxiosPromise<Array<ProductTypeEnumEnumWithDescription>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiInterface
     */
    apiUtilitiesRefreshSettingsGet(options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Validate field Should be called when Validator is known and it would bypass conditional validation.  UI should make dession if this validation shuld be called
     * @param {string} validatorName Name opf the validator type
     * @param {string} modelName Name of the model type
     * @param {boolean} allowNullorEmpty allow empty field
     * @param {string} fieldName name of the field
     * @param {any} [body] Serialized Json Model to be validated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiInterface
     */
    apiUtilitiesValidateFieldValidatorNameModelNameFieldNameAllowNullorEmptyPost(validatorName: string, modelName: string, allowNullorEmpty: boolean, fieldName: string, body?: any, options?: AxiosRequestConfig): AxiosPromise<boolean>;

    /**
     * 
     * @summary This endpoint should be envokend when Validator is unknown.  All validators which applied to the specific property of the   Model will be envoked conditionaly based on Advanced validator Settings.
     * @param {string} modelName Name of the model type
     * @param {string} propertyName name of the property
     * @param {any} [body] Serialized Json Model to be validated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApiInterface
     */
    apiUtilitiesValidatePropertyModelNamePropertyNamePost(modelName: string, propertyName: string, body?: any, options?: AxiosRequestConfig): AxiosPromise<boolean>;

}

/**
 * UtilitiesApi - object-oriented interface
 * @export
 * @class UtilitiesApi
 * @extends {BaseAPI}
 */
export class UtilitiesApi extends BaseAPI implements UtilitiesApiInterface {
    /**
     * 
     * @summary Application types with Description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApi
     */
    public apiUtilitiesApplicationTypesGet(options?: AxiosRequestConfig) {
        return UtilitiesApiFp(this.configuration).apiUtilitiesApplicationTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list of countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApi
     */
    public apiUtilitiesCountriesGet(options?: AxiosRequestConfig) {
        return UtilitiesApiFp(this.configuration).apiUtilitiesCountriesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Document types with Description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApi
     */
    public apiUtilitiesDocumentTypesGet(options?: AxiosRequestConfig) {
        return UtilitiesApiFp(this.configuration).apiUtilitiesDocumentTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns values for dropdowns
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApi
     */
    public apiUtilitiesDropdownContentGet(options?: AxiosRequestConfig) {
        return UtilitiesApiFp(this.configuration).apiUtilitiesDropdownContentGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [model] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApi
     */
    public apiUtilitiesModelsettingsGet(model?: string, options?: AxiosRequestConfig) {
        return UtilitiesApiFp(this.configuration).apiUtilitiesModelsettingsGet(model, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary PortfolioAllocationType for Product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApi
     */
    public apiUtilitiesPortfolioAllocationTypesGet(options?: AxiosRequestConfig) {
        return UtilitiesApiFp(this.configuration).apiUtilitiesPortfolioAllocationTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Product types with Description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApi
     */
    public apiUtilitiesProductTypesGet(options?: AxiosRequestConfig) {
        return UtilitiesApiFp(this.configuration).apiUtilitiesProductTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApi
     */
    public apiUtilitiesRefreshSettingsGet(options?: AxiosRequestConfig) {
        return UtilitiesApiFp(this.configuration).apiUtilitiesRefreshSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate field Should be called when Validator is known and it would bypass conditional validation.  UI should make dession if this validation shuld be called
     * @param {string} validatorName Name opf the validator type
     * @param {string} modelName Name of the model type
     * @param {boolean} allowNullorEmpty allow empty field
     * @param {string} fieldName name of the field
     * @param {any} [body] Serialized Json Model to be validated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApi
     */
    public apiUtilitiesValidateFieldValidatorNameModelNameFieldNameAllowNullorEmptyPost(validatorName: string, modelName: string, allowNullorEmpty: boolean, fieldName: string, body?: any, options?: AxiosRequestConfig) {
        return UtilitiesApiFp(this.configuration).apiUtilitiesValidateFieldValidatorNameModelNameFieldNameAllowNullorEmptyPost(validatorName, modelName, allowNullorEmpty, fieldName, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This endpoint should be envokend when Validator is unknown.  All validators which applied to the specific property of the   Model will be envoked conditionaly based on Advanced validator Settings.
     * @param {string} modelName Name of the model type
     * @param {string} propertyName name of the property
     * @param {any} [body] Serialized Json Model to be validated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitiesApi
     */
    public apiUtilitiesValidatePropertyModelNamePropertyNamePost(modelName: string, propertyName: string, body?: any, options?: AxiosRequestConfig) {
        return UtilitiesApiFp(this.configuration).apiUtilitiesValidatePropertyModelNamePropertyNamePost(modelName, propertyName, body, options).then((request) => request(this.axios, this.basePath));
    }
}


